import React from 'react';

export const Alert = () => {
  return (
    <svg width="259" height="224" viewBox="0 0 259 224" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M133.701 0.325195H129.16V4.8662H133.701V0.325195Z" fill="white" />
      <path d="M145.054 0.325195H140.513V4.8662H145.054V0.325195Z" fill="white" />
      <path d="M156.406 0.325195H151.865V4.8662H156.406V0.325195Z" fill="white" />
      <path d="M167.759 0.325195H163.218V4.8662H167.759V0.325195Z" fill="white" />
      <path d="M179.111 0.325195H174.57V4.8662H179.111V0.325195Z" fill="white" />
      <path d="M190.464 0.325195H185.923V4.8662H190.464V0.325195Z" fill="white" />
      <path d="M201.815 0.325195H197.274V4.8662H201.815V0.325195Z" fill="white" />
      <path d="M213.169 0.325195H208.628V4.8662H213.169V0.325195Z" fill="white" />
      <path d="M224.522 0.325195H219.981V4.8662H224.522V0.325195Z" fill="white" />
      <path d="M235.875 0.325195H231.334V4.8662H235.875V0.325195Z" fill="white" />
      <path d="M247.227 0.325195H242.686V4.8662H247.227V0.325195Z" fill="white" />
      <path d="M258.578 0.325195H254.037V4.8662H258.578V0.325195Z" fill="white" />
      <path d="M133.701 11.6772H129.16V16.2182H133.701V11.6772Z" fill="white" />
      <path d="M145.054 11.6772H140.513V16.2182H145.054V11.6772Z" fill="white" />
      <path d="M156.406 11.6772H151.865V16.2182H156.406V11.6772Z" fill="white" />
      <path d="M167.759 11.6772H163.218V16.2182H167.759V11.6772Z" fill="white" />
      <path d="M179.111 11.6772H174.57V16.2182H179.111V11.6772Z" fill="white" />
      <path d="M190.464 11.6772H185.923V16.2182H190.464V11.6772Z" fill="white" />
      <path d="M201.815 11.6772H197.274V16.2182H201.815V11.6772Z" fill="white" />
      <path d="M213.169 11.6772H208.628V16.2182H213.169V11.6772Z" fill="white" />
      <path d="M224.522 11.6772H219.981V16.2182H224.522V11.6772Z" fill="white" />
      <path d="M235.875 11.6772H231.334V16.2182H235.875V11.6772Z" fill="white" />
      <path d="M247.227 11.6772H242.686V16.2182H247.227V11.6772Z" fill="white" />
      <path d="M258.578 11.6772H254.037V16.2182H258.578V11.6772Z" fill="white" />
      <path d="M133.701 23.0303H129.16V27.5713H133.701V23.0303Z" fill="white" />
      <path d="M145.054 23.0303H140.513V27.5713H145.054V23.0303Z" fill="white" />
      <path d="M156.406 23.0303H151.865V27.5713H156.406V23.0303Z" fill="white" />
      <path d="M167.759 23.0303H163.218V27.5713H167.759V23.0303Z" fill="white" />
      <path d="M179.111 23.0303H174.57V27.5713H179.111V23.0303Z" fill="white" />
      <path d="M190.464 23.0303H185.923V27.5713H190.464V23.0303Z" fill="white" />
      <path d="M201.815 23.0303H197.274V27.5713H201.815V23.0303Z" fill="white" />
      <path d="M213.169 23.0303H208.628V27.5713H213.169V23.0303Z" fill="white" />
      <path d="M224.522 23.0303H219.981V27.5713H224.522V23.0303Z" fill="white" />
      <path d="M235.875 23.0303H231.334V27.5713H235.875V23.0303Z" fill="white" />
      <path d="M247.227 23.0303H242.686V27.5713H247.227V23.0303Z" fill="white" />
      <path d="M258.578 23.0303H254.037V27.5713H258.578V23.0303Z" fill="white" />
      <path d="M133.701 34.3833H129.16V38.9243H133.701V34.3833Z" fill="white" />
      <path d="M145.054 34.3833H140.513V38.9243H145.054V34.3833Z" fill="white" />
      <path d="M156.406 34.3833H151.865V38.9243H156.406V34.3833Z" fill="white" />
      <path d="M167.759 34.3833H163.218V38.9243H167.759V34.3833Z" fill="white" />
      <path d="M179.111 34.3833H174.57V38.9243H179.111V34.3833Z" fill="white" />
      <path d="M190.464 34.3833H185.923V38.9243H190.464V34.3833Z" fill="white" />
      <path d="M201.815 34.3833H197.274V38.9243H201.815V34.3833Z" fill="white" />
      <path d="M213.169 34.3833H208.628V38.9243H213.169V34.3833Z" fill="white" />
      <path d="M224.522 34.3833H219.981V38.9243H224.522V34.3833Z" fill="white" />
      <path d="M235.875 34.3833H231.334V38.9243H235.875V34.3833Z" fill="white" />
      <path d="M247.227 34.3833H242.686V38.9243H247.227V34.3833Z" fill="white" />
      <path d="M258.578 34.3833H254.037V38.9243H258.578V34.3833Z" fill="white" />
      <path d="M133.701 45.7354H129.16V50.2764H133.701V45.7354Z" fill="white" />
      <path d="M145.054 45.7354H140.513V50.2764H145.054V45.7354Z" fill="white" />
      <path d="M156.406 45.7354H151.865V50.2764H156.406V45.7354Z" fill="white" />
      <path d="M167.759 45.7354H163.218V50.2764H167.759V45.7354Z" fill="white" />
      <path d="M179.111 45.7354H174.57V50.2764H179.111V45.7354Z" fill="white" />
      <path d="M190.464 45.7354H185.923V50.2764H190.464V45.7354Z" fill="white" />
      <path d="M201.815 45.7354H197.274V50.2764H201.815V45.7354Z" fill="white" />
      <path d="M213.169 45.7354H208.628V50.2764H213.169V45.7354Z" fill="white" />
      <path d="M224.522 45.7354H219.981V50.2764H224.522V45.7354Z" fill="white" />
      <path d="M235.875 45.7354H231.334V50.2764H235.875V45.7354Z" fill="white" />
      <path d="M247.227 45.7354H242.686V50.2764H247.227V45.7354Z" fill="white" />
      <path d="M258.578 45.7354H254.037V50.2764H258.578V45.7354Z" fill="white" />
      <path d="M133.701 57.0884H129.16V61.6294H133.701V57.0884Z" fill="white" />
      <path d="M145.054 57.0884H140.513V61.6294H145.054V57.0884Z" fill="white" />
      <path d="M156.406 57.0884H151.865V61.6294H156.406V57.0884Z" fill="white" />
      <path d="M167.759 57.0884H163.218V61.6294H167.759V57.0884Z" fill="white" />
      <path d="M179.111 57.0884H174.57V61.6294H179.111V57.0884Z" fill="white" />
      <path d="M190.464 57.0884H185.923V61.6294H190.464V57.0884Z" fill="white" />
      <path d="M201.815 57.0884H197.274V61.6294H201.815V57.0884Z" fill="white" />
      <path d="M213.169 57.0884H208.628V61.6294H213.169V57.0884Z" fill="white" />
      <path d="M224.522 57.0884H219.981V61.6294H224.522V57.0884Z" fill="white" />
      <path d="M235.875 57.0884H231.334V61.6294H235.875V57.0884Z" fill="white" />
      <path d="M247.227 57.0884H242.686V61.6294H247.227V57.0884Z" fill="white" />
      <path d="M258.578 57.0884H254.037V61.6294H258.578V57.0884Z" fill="white" />
      <path d="M133.701 68.4414H129.16V72.9824H133.701V68.4414Z" fill="white" />
      <path d="M145.054 68.4414H140.513V72.9824H145.054V68.4414Z" fill="white" />
      <path d="M156.406 68.4414H151.865V72.9824H156.406V68.4414Z" fill="white" />
      <path d="M167.759 68.4414H163.218V72.9824H167.759V68.4414Z" fill="white" />
      <path d="M179.111 68.4414H174.57V72.9824H179.111V68.4414Z" fill="white" />
      <path d="M190.464 68.4414H185.923V72.9824H190.464V68.4414Z" fill="white" />
      <path d="M201.815 68.4414H197.274V72.9824H201.815V68.4414Z" fill="white" />
      <path d="M213.169 68.4414H208.628V72.9824H213.169V68.4414Z" fill="white" />
      <path d="M224.522 68.4414H219.981V72.9824H224.522V68.4414Z" fill="white" />
      <path d="M235.875 68.4414H231.334V72.9824H235.875V68.4414Z" fill="white" />
      <path d="M247.227 68.4414H242.686V72.9824H247.227V68.4414Z" fill="white" />
      <path d="M258.578 68.4414H254.037V72.9824H258.578V68.4414Z" fill="white" />
      <path d="M133.701 79.793H129.16V84.334H133.701V79.793Z" fill="white" />
      <path d="M145.054 79.793H140.513V84.334H145.054V79.793Z" fill="white" />
      <path d="M156.406 79.793H151.865V84.334H156.406V79.793Z" fill="white" />
      <path d="M167.759 79.793H163.218V84.334H167.759V79.793Z" fill="white" />
      <path d="M179.111 79.793H174.57V84.334H179.111V79.793Z" fill="white" />
      <path d="M190.464 79.793H185.923V84.334H190.464V79.793Z" fill="white" />
      <path d="M201.815 79.793H197.274V84.334H201.815V79.793Z" fill="white" />
      <path d="M213.169 79.793H208.628V84.334H213.169V79.793Z" fill="white" />
      <path d="M224.522 79.793H219.981V84.334H224.522V79.793Z" fill="white" />
      <path d="M235.875 79.793H231.334V84.334H235.875V79.793Z" fill="white" />
      <path d="M247.227 79.793H242.686V84.334H247.227V79.793Z" fill="white" />
      <path d="M258.578 79.793H254.037V84.334H258.578V79.793Z" fill="white" />
      <path d="M133.701 91.146H129.16V95.687H133.701V91.146Z" fill="white" />
      <path d="M145.054 91.146H140.513V95.687H145.054V91.146Z" fill="white" />
      <path d="M156.406 91.146H151.865V95.687H156.406V91.146Z" fill="white" />
      <path d="M167.759 91.146H163.218V95.687H167.759V91.146Z" fill="white" />
      <path d="M179.111 91.146H174.57V95.687H179.111V91.146Z" fill="white" />
      <path d="M190.464 91.146H185.923V95.687H190.464V91.146Z" fill="white" />
      <path d="M201.815 91.146H197.274V95.687H201.815V91.146Z" fill="white" />
      <path d="M213.169 91.146H208.628V95.687H213.169V91.146Z" fill="white" />
      <path d="M224.522 91.146H219.981V95.687H224.522V91.146Z" fill="white" />
      <path d="M235.875 91.146H231.334V95.687H235.875V91.146Z" fill="white" />
      <path d="M247.227 91.146H242.686V95.687H247.227V91.146Z" fill="white" />
      <path d="M258.578 91.146H254.037V95.687H258.578V91.146Z" fill="white" />
      <path d="M133.701 102.498H129.16V107.039H133.701V102.498Z" fill="white" />
      <path d="M145.054 102.498H140.513V107.039H145.054V102.498Z" fill="white" />
      <path d="M156.406 102.498H151.865V107.039H156.406V102.498Z" fill="white" />
      <path d="M167.759 102.498H163.218V107.039H167.759V102.498Z" fill="white" />
      <path d="M179.111 102.498H174.57V107.039H179.111V102.498Z" fill="white" />
      <path d="M190.464 102.498H185.923V107.039H190.464V102.498Z" fill="white" />
      <path d="M201.815 102.498H197.274V107.039H201.815V102.498Z" fill="white" />
      <path d="M213.169 102.498H208.628V107.039H213.169V102.498Z" fill="white" />
      <path d="M224.522 102.498H219.981V107.039H224.522V102.498Z" fill="white" />
      <path d="M235.875 102.498H231.334V107.039H235.875V102.498Z" fill="white" />
      <path d="M247.227 102.498H242.686V107.039H247.227V102.498Z" fill="white" />
      <path d="M258.578 102.498H254.037V107.039H258.578V102.498Z" fill="white" />
      <path d="M133.701 113.851H129.16V118.392H133.701V113.851Z" fill="white" />
      <path d="M145.054 113.851H140.513V118.392H145.054V113.851Z" fill="white" />
      <path d="M156.406 113.851H151.865V118.392H156.406V113.851Z" fill="white" />
      <path d="M167.759 113.851H163.218V118.392H167.759V113.851Z" fill="white" />
      <path d="M179.111 113.851H174.57V118.392H179.111V113.851Z" fill="white" />
      <path d="M190.464 113.851H185.923V118.392H190.464V113.851Z" fill="white" />
      <path d="M201.815 113.851H197.274V118.392H201.815V113.851Z" fill="white" />
      <path d="M213.169 113.851H208.628V118.392H213.169V113.851Z" fill="white" />
      <path d="M224.522 113.851H219.981V118.392H224.522V113.851Z" fill="white" />
      <path d="M235.875 113.851H231.334V118.392H235.875V113.851Z" fill="white" />
      <path d="M247.227 113.851H242.686V118.392H247.227V113.851Z" fill="white" />
      <path d="M258.578 113.851H254.037V118.392H258.578V113.851Z" fill="white" />
      <path d="M133.701 125.204H129.16V129.745H133.701V125.204Z" fill="white" />
      <path d="M145.054 125.204H140.513V129.745H145.054V125.204Z" fill="white" />
      <path d="M156.406 125.204H151.865V129.745H156.406V125.204Z" fill="white" />
      <path d="M167.759 125.204H163.218V129.745H167.759V125.204Z" fill="white" />
      <path d="M179.111 125.204H174.57V129.745H179.111V125.204Z" fill="white" />
      <path d="M190.464 125.204H185.923V129.745H190.464V125.204Z" fill="white" />
      <path d="M201.815 125.204H197.274V129.745H201.815V125.204Z" fill="white" />
      <path d="M213.169 125.204H208.628V129.745H213.169V125.204Z" fill="white" />
      <path d="M224.522 125.204H219.981V129.745H224.522V125.204Z" fill="white" />
      <path d="M235.875 125.204H231.334V129.745H235.875V125.204Z" fill="white" />
      <path d="M247.227 125.204H242.686V129.745H247.227V125.204Z" fill="white" />
      <path d="M258.578 125.204H254.037V129.745H258.578V125.204Z" fill="white" />
      <path
        d="M119.175 45.9001L61.8995 103.176C56.4322 108.643 56.4322 117.507 61.8995 122.975L119.175 180.25C124.642 185.718 133.507 185.718 138.974 180.25L196.25 122.975C201.717 117.507 201.717 108.643 196.25 103.176L138.974 45.9001C133.507 40.4327 124.642 40.4327 119.175 45.9001Z"
        fill="white"
      />
      <path
        d="M112.671 35.1528L51.1527 96.6711C41.9753 105.848 41.9753 120.728 51.1527 129.905L112.671 191.423C121.848 200.601 136.728 200.601 145.905 191.423L207.423 129.905C216.601 120.728 216.601 105.848 207.423 96.6711L145.905 35.1528C136.728 25.9755 121.848 25.9755 112.671 35.1528Z"
        stroke="black"
        strokeWidth="5"
      />
      <path d="M129.797 74.6191V132.373" stroke="#EF4646" strokeWidth="6" strokeLinecap="round" />
      <path
        d="M129.797 153.623C132.505 153.623 134.701 151.427 134.701 148.719C134.701 146.011 132.505 143.815 129.797 143.815C127.089 143.815 124.893 146.011 124.893 148.719C124.893 151.427 127.089 153.623 129.797 153.623Z"
        fill="#EF4646"
      />
    </svg>
  );
};

export const AlertErrorSignature = () => {
  return (
    <svg width="259" height="224" viewBox="0 0 259 224" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M133.701 0.325195H129.16V4.8662H133.701V0.325195Z" fill="white" />
      <path d="M145.054 0.325195H140.513V4.8662H145.054V0.325195Z" fill="white" />
      <path d="M156.406 0.325195H151.865V4.8662H156.406V0.325195Z" fill="white" />
      <path d="M167.759 0.325195H163.218V4.8662H167.759V0.325195Z" fill="white" />
      <path d="M179.111 0.325195H174.57V4.8662H179.111V0.325195Z" fill="white" />
      <path d="M190.464 0.325195H185.923V4.8662H190.464V0.325195Z" fill="white" />
      <path d="M201.815 0.325195H197.274V4.8662H201.815V0.325195Z" fill="white" />
      <path d="M213.169 0.325195H208.628V4.8662H213.169V0.325195Z" fill="white" />
      <path d="M224.522 0.325195H219.981V4.8662H224.522V0.325195Z" fill="white" />
      <path d="M235.875 0.325195H231.334V4.8662H235.875V0.325195Z" fill="white" />
      <path d="M247.228 0.325195H242.687V4.8662H247.228V0.325195Z" fill="white" />
      <path d="M258.578 0.325195H254.037V4.8662H258.578V0.325195Z" fill="white" />
      <path d="M133.701 11.6772H129.16V16.2182H133.701V11.6772Z" fill="white" />
      <path d="M145.054 11.6772H140.513V16.2182H145.054V11.6772Z" fill="white" />
      <path d="M156.406 11.6772H151.865V16.2182H156.406V11.6772Z" fill="white" />
      <path d="M167.759 11.6772H163.218V16.2182H167.759V11.6772Z" fill="white" />
      <path d="M179.111 11.6772H174.57V16.2182H179.111V11.6772Z" fill="white" />
      <path d="M190.464 11.6772H185.923V16.2182H190.464V11.6772Z" fill="white" />
      <path d="M201.815 11.6772H197.274V16.2182H201.815V11.6772Z" fill="white" />
      <path d="M213.169 11.6772H208.628V16.2182H213.169V11.6772Z" fill="white" />
      <path d="M224.522 11.6772H219.981V16.2182H224.522V11.6772Z" fill="white" />
      <path d="M235.875 11.6772H231.334V16.2182H235.875V11.6772Z" fill="white" />
      <path d="M247.228 11.6772H242.687V16.2182H247.228V11.6772Z" fill="white" />
      <path d="M258.578 11.6772H254.037V16.2182H258.578V11.6772Z" fill="white" />
      <path d="M133.701 23.0303H129.16V27.5713H133.701V23.0303Z" fill="white" />
      <path d="M145.054 23.0303H140.513V27.5713H145.054V23.0303Z" fill="white" />
      <path d="M156.406 23.0303H151.865V27.5713H156.406V23.0303Z" fill="white" />
      <path d="M167.759 23.0303H163.218V27.5713H167.759V23.0303Z" fill="white" />
      <path d="M179.111 23.0303H174.57V27.5713H179.111V23.0303Z" fill="white" />
      <path d="M190.464 23.0303H185.923V27.5713H190.464V23.0303Z" fill="white" />
      <path d="M201.815 23.0303H197.274V27.5713H201.815V23.0303Z" fill="white" />
      <path d="M213.169 23.0303H208.628V27.5713H213.169V23.0303Z" fill="white" />
      <path d="M224.522 23.0303H219.981V27.5713H224.522V23.0303Z" fill="white" />
      <path d="M235.875 23.0303H231.334V27.5713H235.875V23.0303Z" fill="white" />
      <path d="M247.228 23.0303H242.687V27.5713H247.228V23.0303Z" fill="white" />
      <path d="M258.578 23.0303H254.037V27.5713H258.578V23.0303Z" fill="white" />
      <path d="M133.701 34.3833H129.16V38.9243H133.701V34.3833Z" fill="white" />
      <path d="M145.054 34.3833H140.513V38.9243H145.054V34.3833Z" fill="white" />
      <path d="M156.406 34.3833H151.865V38.9243H156.406V34.3833Z" fill="white" />
      <path d="M167.759 34.3833H163.218V38.9243H167.759V34.3833Z" fill="white" />
      <path d="M179.111 34.3833H174.57V38.9243H179.111V34.3833Z" fill="white" />
      <path d="M190.464 34.3833H185.923V38.9243H190.464V34.3833Z" fill="white" />
      <path d="M201.815 34.3833H197.274V38.9243H201.815V34.3833Z" fill="white" />
      <path d="M213.169 34.3833H208.628V38.9243H213.169V34.3833Z" fill="white" />
      <path d="M224.522 34.3833H219.981V38.9243H224.522V34.3833Z" fill="white" />
      <path d="M235.875 34.3833H231.334V38.9243H235.875V34.3833Z" fill="white" />
      <path d="M247.228 34.3833H242.687V38.9243H247.228V34.3833Z" fill="white" />
      <path d="M258.578 34.3833H254.037V38.9243H258.578V34.3833Z" fill="white" />
      <path d="M133.701 45.7354H129.16V50.2764H133.701V45.7354Z" fill="white" />
      <path d="M145.054 45.7354H140.513V50.2764H145.054V45.7354Z" fill="white" />
      <path d="M156.406 45.7354H151.865V50.2764H156.406V45.7354Z" fill="white" />
      <path d="M167.759 45.7354H163.218V50.2764H167.759V45.7354Z" fill="white" />
      <path d="M179.111 45.7354H174.57V50.2764H179.111V45.7354Z" fill="white" />
      <path d="M190.464 45.7354H185.923V50.2764H190.464V45.7354Z" fill="white" />
      <path d="M201.815 45.7354H197.274V50.2764H201.815V45.7354Z" fill="white" />
      <path d="M213.169 45.7354H208.628V50.2764H213.169V45.7354Z" fill="white" />
      <path d="M224.522 45.7354H219.981V50.2764H224.522V45.7354Z" fill="white" />
      <path d="M235.875 45.7354H231.334V50.2764H235.875V45.7354Z" fill="white" />
      <path d="M247.228 45.7354H242.687V50.2764H247.228V45.7354Z" fill="white" />
      <path d="M258.578 45.7354H254.037V50.2764H258.578V45.7354Z" fill="white" />
      <path d="M133.701 57.0884H129.16V61.6294H133.701V57.0884Z" fill="white" />
      <path d="M145.054 57.0884H140.513V61.6294H145.054V57.0884Z" fill="white" />
      <path d="M156.406 57.0884H151.865V61.6294H156.406V57.0884Z" fill="white" />
      <path d="M167.759 57.0884H163.218V61.6294H167.759V57.0884Z" fill="white" />
      <path d="M179.111 57.0884H174.57V61.6294H179.111V57.0884Z" fill="white" />
      <path d="M190.464 57.0884H185.923V61.6294H190.464V57.0884Z" fill="white" />
      <path d="M201.815 57.0884H197.274V61.6294H201.815V57.0884Z" fill="white" />
      <path d="M213.169 57.0884H208.628V61.6294H213.169V57.0884Z" fill="white" />
      <path d="M224.522 57.0884H219.981V61.6294H224.522V57.0884Z" fill="white" />
      <path d="M235.875 57.0884H231.334V61.6294H235.875V57.0884Z" fill="white" />
      <path d="M247.228 57.0884H242.687V61.6294H247.228V57.0884Z" fill="white" />
      <path d="M258.578 57.0884H254.037V61.6294H258.578V57.0884Z" fill="white" />
      <path d="M133.701 68.4414H129.16V72.9824H133.701V68.4414Z" fill="white" />
      <path d="M145.054 68.4414H140.513V72.9824H145.054V68.4414Z" fill="white" />
      <path d="M156.406 68.4414H151.865V72.9824H156.406V68.4414Z" fill="white" />
      <path d="M167.759 68.4414H163.218V72.9824H167.759V68.4414Z" fill="white" />
      <path d="M179.111 68.4414H174.57V72.9824H179.111V68.4414Z" fill="white" />
      <path d="M190.464 68.4414H185.923V72.9824H190.464V68.4414Z" fill="white" />
      <path d="M201.815 68.4414H197.274V72.9824H201.815V68.4414Z" fill="white" />
      <path d="M213.169 68.4414H208.628V72.9824H213.169V68.4414Z" fill="white" />
      <path d="M224.522 68.4414H219.981V72.9824H224.522V68.4414Z" fill="white" />
      <path d="M235.875 68.4414H231.334V72.9824H235.875V68.4414Z" fill="white" />
      <path d="M247.228 68.4414H242.687V72.9824H247.228V68.4414Z" fill="white" />
      <path d="M258.578 68.4414H254.037V72.9824H258.578V68.4414Z" fill="white" />
      <path d="M133.701 79.793H129.16V84.334H133.701V79.793Z" fill="white" />
      <path d="M145.054 79.793H140.513V84.334H145.054V79.793Z" fill="white" />
      <path d="M156.406 79.793H151.865V84.334H156.406V79.793Z" fill="white" />
      <path d="M167.759 79.793H163.218V84.334H167.759V79.793Z" fill="white" />
      <path d="M179.111 79.793H174.57V84.334H179.111V79.793Z" fill="white" />
      <path d="M190.464 79.793H185.923V84.334H190.464V79.793Z" fill="white" />
      <path d="M201.815 79.793H197.274V84.334H201.815V79.793Z" fill="white" />
      <path d="M213.169 79.793H208.628V84.334H213.169V79.793Z" fill="white" />
      <path d="M224.522 79.793H219.981V84.334H224.522V79.793Z" fill="white" />
      <path d="M235.875 79.793H231.334V84.334H235.875V79.793Z" fill="white" />
      <path d="M247.228 79.793H242.687V84.334H247.228V79.793Z" fill="white" />
      <path d="M258.578 79.793H254.037V84.334H258.578V79.793Z" fill="white" />
      <path d="M133.701 91.146H129.16V95.687H133.701V91.146Z" fill="white" />
      <path d="M145.054 91.146H140.513V95.687H145.054V91.146Z" fill="white" />
      <path d="M156.406 91.146H151.865V95.687H156.406V91.146Z" fill="white" />
      <path d="M167.759 91.146H163.218V95.687H167.759V91.146Z" fill="white" />
      <path d="M179.111 91.146H174.57V95.687H179.111V91.146Z" fill="white" />
      <path d="M190.464 91.146H185.923V95.687H190.464V91.146Z" fill="white" />
      <path d="M201.815 91.146H197.274V95.687H201.815V91.146Z" fill="white" />
      <path d="M213.169 91.146H208.628V95.687H213.169V91.146Z" fill="white" />
      <path d="M224.522 91.146H219.981V95.687H224.522V91.146Z" fill="white" />
      <path d="M235.875 91.146H231.334V95.687H235.875V91.146Z" fill="white" />
      <path d="M247.228 91.146H242.687V95.687H247.228V91.146Z" fill="white" />
      <path d="M258.578 91.146H254.037V95.687H258.578V91.146Z" fill="white" />
      <path d="M133.701 102.498H129.16V107.039H133.701V102.498Z" fill="white" />
      <path d="M145.054 102.498H140.513V107.039H145.054V102.498Z" fill="white" />
      <path d="M156.406 102.498H151.865V107.039H156.406V102.498Z" fill="white" />
      <path d="M167.759 102.498H163.218V107.039H167.759V102.498Z" fill="white" />
      <path d="M179.111 102.498H174.57V107.039H179.111V102.498Z" fill="white" />
      <path d="M190.464 102.498H185.923V107.039H190.464V102.498Z" fill="white" />
      <path d="M201.815 102.498H197.274V107.039H201.815V102.498Z" fill="white" />
      <path d="M213.169 102.498H208.628V107.039H213.169V102.498Z" fill="white" />
      <path d="M224.522 102.498H219.981V107.039H224.522V102.498Z" fill="white" />
      <path d="M235.875 102.498H231.334V107.039H235.875V102.498Z" fill="white" />
      <path d="M247.228 102.498H242.687V107.039H247.228V102.498Z" fill="white" />
      <path d="M258.578 102.498H254.037V107.039H258.578V102.498Z" fill="white" />
      <path d="M133.701 113.851H129.16V118.392H133.701V113.851Z" fill="white" />
      <path d="M145.054 113.851H140.513V118.392H145.054V113.851Z" fill="white" />
      <path d="M156.406 113.851H151.865V118.392H156.406V113.851Z" fill="white" />
      <path d="M167.759 113.851H163.218V118.392H167.759V113.851Z" fill="white" />
      <path d="M179.111 113.851H174.57V118.392H179.111V113.851Z" fill="white" />
      <path d="M190.464 113.851H185.923V118.392H190.464V113.851Z" fill="white" />
      <path d="M201.815 113.851H197.274V118.392H201.815V113.851Z" fill="white" />
      <path d="M213.169 113.851H208.628V118.392H213.169V113.851Z" fill="white" />
      <path d="M224.522 113.851H219.981V118.392H224.522V113.851Z" fill="white" />
      <path d="M235.875 113.851H231.334V118.392H235.875V113.851Z" fill="white" />
      <path d="M247.228 113.851H242.687V118.392H247.228V113.851Z" fill="white" />
      <path d="M258.578 113.851H254.037V118.392H258.578V113.851Z" fill="white" />
      <path d="M133.701 125.204H129.16V129.745H133.701V125.204Z" fill="white" />
      <path d="M145.054 125.204H140.513V129.745H145.054V125.204Z" fill="white" />
      <path d="M156.406 125.204H151.865V129.745H156.406V125.204Z" fill="white" />
      <path d="M167.759 125.204H163.218V129.745H167.759V125.204Z" fill="white" />
      <path d="M179.111 125.204H174.57V129.745H179.111V125.204Z" fill="white" />
      <path d="M190.464 125.204H185.923V129.745H190.464V125.204Z" fill="white" />
      <path d="M201.815 125.204H197.274V129.745H201.815V125.204Z" fill="white" />
      <path d="M213.169 125.204H208.628V129.745H213.169V125.204Z" fill="white" />
      <path d="M224.522 125.204H219.981V129.745H224.522V125.204Z" fill="white" />
      <path d="M235.875 125.204H231.334V129.745H235.875V125.204Z" fill="white" />
      <path d="M247.228 125.204H242.687V129.745H247.228V125.204Z" fill="white" />
      <path d="M258.578 125.204H254.037V129.745H258.578V125.204Z" fill="white" />
      <path
        d="M119.175 45.9001L61.8995 103.176C56.4322 108.643 56.4322 117.507 61.8995 122.975L119.175 180.25C124.642 185.718 133.507 185.718 138.974 180.25L196.25 122.975C201.717 117.507 201.717 108.643 196.25 103.176L138.974 45.9001C133.507 40.4327 124.642 40.4327 119.175 45.9001Z"
        fill="white"
      />
      <path
        d="M112.67 35.1528L51.1522 96.6711C41.9748 105.848 41.9748 120.728 51.1522 129.905L112.67 191.423C121.848 200.601 136.727 200.601 145.904 191.423L207.423 129.905C216.6 120.728 216.6 105.848 207.423 96.6711L145.904 35.1528C136.727 25.9755 121.848 25.9755 112.67 35.1528Z"
        stroke="black"
        strokeWidth="5"
      />
      <path d="M129.797 74.6191V132.373" stroke="#EFE246" strokeWidth="6" strokeLinecap="round" />
      <path
        d="M129.797 153.623C132.505 153.623 134.701 151.427 134.701 148.719C134.701 146.011 132.505 143.815 129.797 143.815C127.088 143.815 124.893 146.011 124.893 148.719C124.893 151.427 127.088 153.623 129.797 153.623Z"
        fill="#EFE246"
      />
      <path
        d="M129.797 153.123C132.229 153.123 134.201 151.151 134.201 148.719C134.201 146.287 132.229 144.315 129.797 144.315C127.364 144.315 125.393 146.287 125.393 148.719C125.393 151.151 127.364 153.123 129.797 153.123Z"
        stroke="#EFE246"
      />
    </svg>
  );
};

export const IconErrorPermissionGeolocation = () => {
  return (
    <svg width="201" height="200" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M200.5 0H196.5V4H200.5V0Z" fill="#E5E5E5" />
      <path d="M200.5 0H196.5V4H200.5V0Z" fill="#DBDBDB" />
      <path d="M200.5 8H196.5V12H200.5V8Z" fill="#E5E5E5" />
      <path d="M200.5 8H196.5V12H200.5V8Z" fill="#DBDBDB" />
      <path d="M200.5 16H196.5V20H200.5V16Z" fill="#E5E5E5" />
      <path d="M200.5 16H196.5V20H200.5V16Z" fill="#DBDBDB" />
      <path d="M200.5 23.996H196.5V27.996H200.5V23.996Z" fill="#E5E5E5" />
      <path d="M200.5 23.996H196.5V27.996H200.5V23.996Z" fill="#DBDBDB" />
      <path d="M200.5 32H196.5V36H200.5V32Z" fill="#E5E5E5" />
      <path d="M200.5 32H196.5V36H200.5V32Z" fill="#DBDBDB" />
      <path d="M200.5 40H196.5V44H200.5V40Z" fill="#E5E5E5" />
      <path d="M200.5 40H196.5V44H200.5V40Z" fill="#DBDBDB" />
      <path d="M200.5 48H196.5V52H200.5V48Z" fill="#E5E5E5" />
      <path d="M200.5 48H196.5V52H200.5V48Z" fill="#DBDBDB" />
      <path d="M200.5 56H196.5V60H200.5V56Z" fill="#E5E5E5" />
      <path d="M200.5 56H196.5V60H200.5V56Z" fill="#DBDBDB" />
      <path d="M200.5 64H196.5V68H200.5V64Z" fill="#E5E5E5" />
      <path d="M200.5 64H196.5V68H200.5V64Z" fill="#DBDBDB" />
      <path d="M200.5 72H196.5V76H200.5V72Z" fill="#E5E5E5" />
      <path d="M200.5 72H196.5V76H200.5V72Z" fill="#DBDBDB" />
      <path d="M200.5 80H196.5V84H200.5V80Z" fill="#E5E5E5" />
      <path d="M200.5 80H196.5V84H200.5V80Z" fill="#DBDBDB" />
      <path d="M200.5 88H196.5V92H200.5V88Z" fill="#E5E5E5" />
      <path d="M200.5 88H196.5V92H200.5V88Z" fill="#DBDBDB" />
      <path d="M200.5 96H196.5V100H200.5V96Z" fill="#E5E5E5" />
      <path d="M200.5 96H196.5V100H200.5V96Z" fill="#DBDBDB" />
      <path d="M92.5 104H96.5V108H92.5V104Z" fill="#E5E5E5" />
      <path d="M92.5 104H96.5V108H92.5V104Z" fill="#DBDBDB" />
      <path d="M104.5 104H100.5V108H104.5V104Z" fill="#E5E5E5" />
      <path d="M104.5 104H100.5V108H104.5V104Z" fill="#DBDBDB" />
      <path d="M108.5 104H112.5V108H108.5V104Z" fill="#E5E5E5" />
      <path d="M108.5 104H112.5V108H108.5V104Z" fill="#DBDBDB" />
      <path d="M120.5 104H116.5V108H120.5V104Z" fill="#E5E5E5" />
      <path d="M120.5 104H116.5V108H120.5V104Z" fill="#DBDBDB" />
      <path d="M124.5 104H128.5V108H124.5V104Z" fill="#E5E5E5" />
      <path d="M124.5 104H128.5V108H124.5V104Z" fill="#DBDBDB" />
      <path d="M136.5 104H132.5V108H136.5V104Z" fill="#E5E5E5" />
      <path d="M136.5 104H132.5V108H136.5V104Z" fill="#DBDBDB" />
      <path d="M140.5 104H144.5V108H140.5V104Z" fill="#E5E5E5" />
      <path d="M140.5 104H144.5V108H140.5V104Z" fill="#DBDBDB" />
      <path d="M152.5 104H148.5V108H152.5V104Z" fill="#E5E5E5" />
      <path d="M152.5 104H148.5V108H152.5V104Z" fill="#DBDBDB" />
      <path d="M156.5 104H160.5V108H156.5V104Z" fill="#E5E5E5" />
      <path d="M156.5 104H160.5V108H156.5V104Z" fill="#DBDBDB" />
      <path d="M168.5 104H164.5V108H168.5V104Z" fill="#E5E5E5" />
      <path d="M168.5 104H164.5V108H168.5V104Z" fill="#DBDBDB" />
      <path d="M172.5 104H176.5V108H172.5V104Z" fill="#E5E5E5" />
      <path d="M172.5 104H176.5V108H172.5V104Z" fill="#DBDBDB" />
      <path d="M184.5 104H180.5V108H184.5V104Z" fill="#E5E5E5" />
      <path d="M184.5 104H180.5V108H184.5V104Z" fill="#DBDBDB" />
      <path d="M188.5 104H192.5V108H188.5V104Z" fill="#E5E5E5" />
      <path d="M188.5 104H192.5V108H188.5V104Z" fill="#DBDBDB" />
      <path d="M196.5 104H200.5V108H196.5V104Z" fill="#E5E5E5" />
      <path d="M196.5 104H200.5V108H196.5V104Z" fill="#DBDBDB" />
      <path d="M188.5 96H192.5V100H188.5V96Z" fill="#E5E5E5" />
      <path d="M188.5 96H192.5V100H188.5V96Z" fill="#DBDBDB" />
      <path d="M184.5 96H180.5V100H184.5V96Z" fill="#E5E5E5" />
      <path d="M184.5 96H180.5V100H184.5V96Z" fill="#DBDBDB" />
      <path d="M172.5 96H176.5V100H172.5V96Z" fill="#E5E5E5" />
      <path d="M172.5 96H176.5V100H172.5V96Z" fill="#DBDBDB" />
      <path d="M168.5 96H164.5V100H168.5V96Z" fill="#E5E5E5" />
      <path d="M168.5 96H164.5V100H168.5V96Z" fill="#DBDBDB" />
      <path d="M156.5 96H160.5V100H156.5V96Z" fill="#E5E5E5" />
      <path d="M156.5 96H160.5V100H156.5V96Z" fill="#DBDBDB" />
      <path d="M152.5 96H148.5V100H152.5V96Z" fill="#E5E5E5" />
      <path d="M152.5 96H148.5V100H152.5V96Z" fill="#DBDBDB" />
      <path d="M140.5 96H144.5V100H140.5V96Z" fill="#E5E5E5" />
      <path d="M140.5 96H144.5V100H140.5V96Z" fill="#DBDBDB" />
      <path d="M136.5 96H132.5V100H136.5V96Z" fill="#E5E5E5" />
      <path d="M136.5 96H132.5V100H136.5V96Z" fill="#DBDBDB" />
      <path d="M124.5 96H128.5V100H124.5V96Z" fill="#E5E5E5" />
      <path d="M124.5 96H128.5V100H124.5V96Z" fill="#DBDBDB" />
      <path d="M120.5 96H116.5V100H120.5V96Z" fill="#E5E5E5" />
      <path d="M120.5 96H116.5V100H120.5V96Z" fill="#DBDBDB" />
      <path d="M108.5 96H112.5V100H108.5V96Z" fill="#E5E5E5" />
      <path d="M108.5 96H112.5V100H108.5V96Z" fill="#DBDBDB" />
      <path d="M104.5 96H100.5V100H104.5V96Z" fill="#E5E5E5" />
      <path d="M104.5 96H100.5V100H104.5V96Z" fill="#DBDBDB" />
      <path d="M92.5 96H96.5V100H92.5V96Z" fill="#E5E5E5" />
      <path d="M92.5 96H96.5V100H92.5V96Z" fill="#DBDBDB" />
      <path d="M188.5 88H192.5V92H188.5V88Z" fill="#E5E5E5" />
      <path d="M188.5 88H192.5V92H188.5V88Z" fill="#DBDBDB" />
      <path d="M184.5 88H180.5V92H184.5V88Z" fill="#E5E5E5" />
      <path d="M184.5 88H180.5V92H184.5V88Z" fill="#DBDBDB" />
      <path d="M172.5 88H176.5V92H172.5V88Z" fill="#E5E5E5" />
      <path d="M172.5 88H176.5V92H172.5V88Z" fill="#DBDBDB" />
      <path d="M168.5 88H164.5V92H168.5V88Z" fill="#E5E5E5" />
      <path d="M168.5 88H164.5V92H168.5V88Z" fill="#DBDBDB" />
      <path d="M156.5 88H160.5V92H156.5V88Z" fill="#E5E5E5" />
      <path d="M156.5 88H160.5V92H156.5V88Z" fill="#DBDBDB" />
      <path d="M152.5 88H148.5V92H152.5V88Z" fill="#E5E5E5" />
      <path d="M152.5 88H148.5V92H152.5V88Z" fill="#DBDBDB" />
      <path d="M140.5 88H144.5V92H140.5V88Z" fill="#E5E5E5" />
      <path d="M140.5 88H144.5V92H140.5V88Z" fill="#DBDBDB" />
      <path d="M136.5 88H132.5V92H136.5V88Z" fill="#E5E5E5" />
      <path d="M136.5 88H132.5V92H136.5V88Z" fill="#DBDBDB" />
      <path d="M124.5 88H128.5V92H124.5V88Z" fill="#E5E5E5" />
      <path d="M124.5 88H128.5V92H124.5V88Z" fill="#DBDBDB" />
      <path d="M120.5 88H116.5V92H120.5V88Z" fill="#E5E5E5" />
      <path d="M120.5 88H116.5V92H120.5V88Z" fill="#DBDBDB" />
      <path d="M108.5 88H112.5V92H108.5V88Z" fill="#E5E5E5" />
      <path d="M108.5 88H112.5V92H108.5V88Z" fill="#DBDBDB" />
      <path d="M104.5 88H100.5V92H104.5V88Z" fill="#E5E5E5" />
      <path d="M104.5 88H100.5V92H104.5V88Z" fill="#DBDBDB" />
      <path d="M92.5 88H96.5V92H92.5V88Z" fill="#E5E5E5" />
      <path d="M92.5 88H96.5V92H92.5V88Z" fill="#DBDBDB" />
      <path d="M188.5 80H192.5V84H188.5V80Z" fill="#E5E5E5" />
      <path d="M188.5 80H192.5V84H188.5V80Z" fill="#DBDBDB" />
      <path d="M184.5 80H180.5V84H184.5V80Z" fill="#E5E5E5" />
      <path d="M184.5 80H180.5V84H184.5V80Z" fill="#DBDBDB" />
      <path d="M172.5 80H176.5V84H172.5V80Z" fill="#E5E5E5" />
      <path d="M172.5 80H176.5V84H172.5V80Z" fill="#DBDBDB" />
      <path d="M168.5 80H164.5V84H168.5V80Z" fill="#E5E5E5" />
      <path d="M168.5 80H164.5V84H168.5V80Z" fill="#DBDBDB" />
      <path d="M156.5 80H160.5V84H156.5V80Z" fill="#E5E5E5" />
      <path d="M156.5 80H160.5V84H156.5V80Z" fill="#DBDBDB" />
      <path d="M152.5 80H148.5V84H152.5V80Z" fill="#E5E5E5" />
      <path d="M152.5 80H148.5V84H152.5V80Z" fill="#DBDBDB" />
      <path d="M140.5 80H144.5V84H140.5V80Z" fill="#E5E5E5" />
      <path d="M140.5 80H144.5V84H140.5V80Z" fill="#DBDBDB" />
      <path d="M136.5 80H132.5V84H136.5V80Z" fill="#E5E5E5" />
      <path d="M136.5 80H132.5V84H136.5V80Z" fill="#DBDBDB" />
      <path d="M124.5 80H128.5V84H124.5V80Z" fill="#E5E5E5" />
      <path d="M124.5 80H128.5V84H124.5V80Z" fill="#DBDBDB" />
      <path d="M120.5 80H116.5V84H120.5V80Z" fill="#E5E5E5" />
      <path d="M120.5 80H116.5V84H120.5V80Z" fill="#DBDBDB" />
      <path d="M108.5 80H112.5V84H108.5V80Z" fill="#E5E5E5" />
      <path d="M108.5 80H112.5V84H108.5V80Z" fill="#DBDBDB" />
      <path d="M104.5 80H100.5V84H104.5V80Z" fill="#E5E5E5" />
      <path d="M104.5 80H100.5V84H104.5V80Z" fill="#DBDBDB" />
      <path d="M92.5 80H96.5V84H92.5V80Z" fill="#E5E5E5" />
      <path d="M92.5 80H96.5V84H92.5V80Z" fill="#DBDBDB" />
      <path d="M188.5 72H192.5V76H188.5V72Z" fill="#E5E5E5" />
      <path d="M188.5 72H192.5V76H188.5V72Z" fill="#DBDBDB" />
      <path d="M184.5 72H180.5V76H184.5V72Z" fill="#E5E5E5" />
      <path d="M184.5 72H180.5V76H184.5V72Z" fill="#DBDBDB" />
      <path d="M172.5 72H176.5V76H172.5V72Z" fill="#E5E5E5" />
      <path d="M172.5 72H176.5V76H172.5V72Z" fill="#DBDBDB" />
      <path d="M168.5 72H164.5V76H168.5V72Z" fill="#E5E5E5" />
      <path d="M168.5 72H164.5V76H168.5V72Z" fill="#DBDBDB" />
      <path d="M156.5 72H160.5V76H156.5V72Z" fill="#E5E5E5" />
      <path d="M156.5 72H160.5V76H156.5V72Z" fill="#DBDBDB" />
      <path d="M152.5 72H148.5V76H152.5V72Z" fill="#E5E5E5" />
      <path d="M152.5 72H148.5V76H152.5V72Z" fill="#DBDBDB" />
      <path d="M140.5 72H144.5V76H140.5V72Z" fill="#E5E5E5" />
      <path d="M140.5 72H144.5V76H140.5V72Z" fill="#DBDBDB" />
      <path d="M136.5 72H132.5V76H136.5V72Z" fill="#E5E5E5" />
      <path d="M136.5 72H132.5V76H136.5V72Z" fill="#DBDBDB" />
      <path d="M124.5 72H128.5V76H124.5V72Z" fill="#E5E5E5" />
      <path d="M124.5 72H128.5V76H124.5V72Z" fill="#DBDBDB" />
      <path d="M120.5 72H116.5V76H120.5V72Z" fill="#E5E5E5" />
      <path d="M120.5 72H116.5V76H120.5V72Z" fill="#DBDBDB" />
      <path d="M108.5 72H112.5V76H108.5V72Z" fill="#E5E5E5" />
      <path d="M108.5 72H112.5V76H108.5V72Z" fill="#DBDBDB" />
      <path d="M104.5 72H100.5V76H104.5V72Z" fill="#E5E5E5" />
      <path d="M104.5 72H100.5V76H104.5V72Z" fill="#DBDBDB" />
      <path d="M92.5 72H96.5V76H92.5V72Z" fill="#E5E5E5" />
      <path d="M92.5 72H96.5V76H92.5V72Z" fill="#DBDBDB" />
      <path d="M188.5 64H192.5V68H188.5V64Z" fill="#E5E5E5" />
      <path d="M188.5 64H192.5V68H188.5V64Z" fill="#DBDBDB" />
      <path d="M184.5 64H180.5V68H184.5V64Z" fill="#E5E5E5" />
      <path d="M184.5 64H180.5V68H184.5V64Z" fill="#DBDBDB" />
      <path d="M172.5 64H176.5V68H172.5V64Z" fill="#E5E5E5" />
      <path d="M172.5 64H176.5V68H172.5V64Z" fill="#DBDBDB" />
      <path d="M168.5 64H164.5V68H168.5V64Z" fill="#E5E5E5" />
      <path d="M168.5 64H164.5V68H168.5V64Z" fill="#DBDBDB" />
      <path d="M156.5 64H160.5V68H156.5V64Z" fill="#E5E5E5" />
      <path d="M156.5 64H160.5V68H156.5V64Z" fill="#DBDBDB" />
      <path d="M152.5 64H148.5V68H152.5V64Z" fill="#E5E5E5" />
      <path d="M152.5 64H148.5V68H152.5V64Z" fill="#DBDBDB" />
      <path d="M140.5 64H144.5V68H140.5V64Z" fill="#E5E5E5" />
      <path d="M140.5 64H144.5V68H140.5V64Z" fill="#DBDBDB" />
      <path d="M136.5 64H132.5V68H136.5V64Z" fill="#E5E5E5" />
      <path d="M136.5 64H132.5V68H136.5V64Z" fill="#DBDBDB" />
      <path d="M124.5 64H128.5V68H124.5V64Z" fill="#E5E5E5" />
      <path d="M124.5 64H128.5V68H124.5V64Z" fill="#DBDBDB" />
      <path d="M120.5 64H116.5V68H120.5V64Z" fill="#E5E5E5" />
      <path d="M120.5 64H116.5V68H120.5V64Z" fill="#DBDBDB" />
      <path d="M108.5 64H112.5V68H108.5V64Z" fill="#E5E5E5" />
      <path d="M108.5 64H112.5V68H108.5V64Z" fill="#DBDBDB" />
      <path d="M104.5 64H100.5V68H104.5V64Z" fill="#E5E5E5" />
      <path d="M104.5 64H100.5V68H104.5V64Z" fill="#DBDBDB" />
      <path d="M92.5 64H96.5V68H92.5V64Z" fill="#E5E5E5" />
      <path d="M92.5 64H96.5V68H92.5V64Z" fill="#DBDBDB" />
      <path d="M188.5 56H192.5V60H188.5V56Z" fill="#E5E5E5" />
      <path d="M188.5 56H192.5V60H188.5V56Z" fill="#DBDBDB" />
      <path d="M184.5 56H180.5V60H184.5V56Z" fill="#E5E5E5" />
      <path d="M184.5 56H180.5V60H184.5V56Z" fill="#DBDBDB" />
      <path d="M172.5 56H176.5V60H172.5V56Z" fill="#E5E5E5" />
      <path d="M172.5 56H176.5V60H172.5V56Z" fill="#DBDBDB" />
      <path d="M168.5 56H164.5V60H168.5V56Z" fill="#E5E5E5" />
      <path d="M168.5 56H164.5V60H168.5V56Z" fill="#DBDBDB" />
      <path d="M156.5 56H160.5V60H156.5V56Z" fill="#E5E5E5" />
      <path d="M156.5 56H160.5V60H156.5V56Z" fill="#DBDBDB" />
      <path d="M152.5 56H148.5V60H152.5V56Z" fill="#E5E5E5" />
      <path d="M152.5 56H148.5V60H152.5V56Z" fill="#DBDBDB" />
      <path d="M140.5 56H144.5V60H140.5V56Z" fill="#E5E5E5" />
      <path d="M140.5 56H144.5V60H140.5V56Z" fill="#DBDBDB" />
      <path d="M136.5 56H132.5V60H136.5V56Z" fill="#E5E5E5" />
      <path d="M136.5 56H132.5V60H136.5V56Z" fill="#DBDBDB" />
      <path d="M124.5 56H128.5V60H124.5V56Z" fill="#E5E5E5" />
      <path d="M124.5 56H128.5V60H124.5V56Z" fill="#DBDBDB" />
      <path d="M120.5 56H116.5V60H120.5V56Z" fill="#E5E5E5" />
      <path d="M120.5 56H116.5V60H120.5V56Z" fill="#DBDBDB" />
      <path d="M108.5 56H112.5V60H108.5V56Z" fill="#E5E5E5" />
      <path d="M108.5 56H112.5V60H108.5V56Z" fill="#DBDBDB" />
      <path d="M104.5 56H100.5V60H104.5V56Z" fill="#E5E5E5" />
      <path d="M104.5 56H100.5V60H104.5V56Z" fill="#DBDBDB" />
      <path d="M92.5 56H96.5V60H92.5V56Z" fill="#E5E5E5" />
      <path d="M92.5 56H96.5V60H92.5V56Z" fill="#DBDBDB" />
      <path d="M188.5 48H192.5V52H188.5V48Z" fill="#E5E5E5" />
      <path d="M188.5 48H192.5V52H188.5V48Z" fill="#DBDBDB" />
      <path d="M184.5 48H180.5V52H184.5V48Z" fill="#E5E5E5" />
      <path d="M184.5 48H180.5V52H184.5V48Z" fill="#DBDBDB" />
      <path d="M172.5 48H176.5V52H172.5V48Z" fill="#E5E5E5" />
      <path d="M172.5 48H176.5V52H172.5V48Z" fill="#DBDBDB" />
      <path d="M168.5 48H164.5V52H168.5V48Z" fill="#E5E5E5" />
      <path d="M168.5 48H164.5V52H168.5V48Z" fill="#DBDBDB" />
      <path d="M156.5 48H160.5V52H156.5V48Z" fill="#E5E5E5" />
      <path d="M156.5 48H160.5V52H156.5V48Z" fill="#DBDBDB" />
      <path d="M152.5 48H148.5V52H152.5V48Z" fill="#E5E5E5" />
      <path d="M152.5 48H148.5V52H152.5V48Z" fill="#DBDBDB" />
      <path d="M140.5 48H144.5V52H140.5V48Z" fill="#E5E5E5" />
      <path d="M140.5 48H144.5V52H140.5V48Z" fill="#DBDBDB" />
      <path d="M136.5 48H132.5V52H136.5V48Z" fill="#E5E5E5" />
      <path d="M136.5 48H132.5V52H136.5V48Z" fill="#DBDBDB" />
      <path d="M124.5 48H128.5V52H124.5V48Z" fill="#E5E5E5" />
      <path d="M124.5 48H128.5V52H124.5V48Z" fill="#DBDBDB" />
      <path d="M120.5 48H116.5V52H120.5V48Z" fill="#E5E5E5" />
      <path d="M120.5 48H116.5V52H120.5V48Z" fill="#DBDBDB" />
      <path d="M108.5 48H112.5V52H108.5V48Z" fill="#E5E5E5" />
      <path d="M108.5 48H112.5V52H108.5V48Z" fill="#DBDBDB" />
      <path d="M104.5 48H100.5V52H104.5V48Z" fill="#E5E5E5" />
      <path d="M104.5 48H100.5V52H104.5V48Z" fill="#DBDBDB" />
      <path d="M92.5 48H96.5V52H92.5V48Z" fill="#E5E5E5" />
      <path d="M92.5 48H96.5V52H92.5V48Z" fill="#DBDBDB" />
      <path d="M188.5 40H192.5V44H188.5V40Z" fill="#E5E5E5" />
      <path d="M188.5 40H192.5V44H188.5V40Z" fill="#DBDBDB" />
      <path d="M184.5 40H180.5V44H184.5V40Z" fill="#E5E5E5" />
      <path d="M184.5 40H180.5V44H184.5V40Z" fill="#DBDBDB" />
      <path d="M172.5 40H176.5V44H172.5V40Z" fill="#E5E5E5" />
      <path d="M172.5 40H176.5V44H172.5V40Z" fill="#DBDBDB" />
      <path d="M168.5 40H164.5V44H168.5V40Z" fill="#E5E5E5" />
      <path d="M168.5 40H164.5V44H168.5V40Z" fill="#DBDBDB" />
      <path d="M156.5 40H160.5V44H156.5V40Z" fill="#E5E5E5" />
      <path d="M156.5 40H160.5V44H156.5V40Z" fill="#DBDBDB" />
      <path d="M152.5 40H148.5V44H152.5V40Z" fill="#E5E5E5" />
      <path d="M152.5 40H148.5V44H152.5V40Z" fill="#DBDBDB" />
      <path d="M140.5 40H144.5V44H140.5V40Z" fill="#E5E5E5" />
      <path d="M140.5 40H144.5V44H140.5V40Z" fill="#DBDBDB" />
      <path d="M136.5 40H132.5V44H136.5V40Z" fill="#E5E5E5" />
      <path d="M136.5 40H132.5V44H136.5V40Z" fill="#DBDBDB" />
      <path d="M124.5 40H128.5V44H124.5V40Z" fill="#E5E5E5" />
      <path d="M124.5 40H128.5V44H124.5V40Z" fill="#DBDBDB" />
      <path d="M120.5 40H116.5V44H120.5V40Z" fill="#E5E5E5" />
      <path d="M120.5 40H116.5V44H120.5V40Z" fill="#DBDBDB" />
      <path d="M108.5 40H112.5V44H108.5V40Z" fill="#E5E5E5" />
      <path d="M108.5 40H112.5V44H108.5V40Z" fill="#DBDBDB" />
      <path d="M104.5 40H100.5V44H104.5V40Z" fill="#E5E5E5" />
      <path d="M104.5 40H100.5V44H104.5V40Z" fill="#DBDBDB" />
      <path d="M92.5 40H96.5V44H92.5V40Z" fill="#E5E5E5" />
      <path d="M92.5 40H96.5V44H92.5V40Z" fill="#DBDBDB" />
      <path d="M188.5 32H192.5V36H188.5V32Z" fill="#E5E5E5" />
      <path d="M188.5 32H192.5V36H188.5V32Z" fill="#DBDBDB" />
      <path d="M184.5 32H180.5V36H184.5V32Z" fill="#E5E5E5" />
      <path d="M184.5 32H180.5V36H184.5V32Z" fill="#DBDBDB" />
      <path d="M172.5 32H176.5V36H172.5V32Z" fill="#E5E5E5" />
      <path d="M172.5 32H176.5V36H172.5V32Z" fill="#DBDBDB" />
      <path d="M168.5 32H164.5V36H168.5V32Z" fill="#E5E5E5" />
      <path d="M168.5 32H164.5V36H168.5V32Z" fill="#DBDBDB" />
      <path d="M156.5 32H160.5V36H156.5V32Z" fill="#E5E5E5" />
      <path d="M156.5 32H160.5V36H156.5V32Z" fill="#DBDBDB" />
      <path d="M152.5 32H148.5V36H152.5V32Z" fill="#E5E5E5" />
      <path d="M152.5 32H148.5V36H152.5V32Z" fill="#DBDBDB" />
      <path d="M140.5 32H144.5V36H140.5V32Z" fill="#E5E5E5" />
      <path d="M140.5 32H144.5V36H140.5V32Z" fill="#DBDBDB" />
      <path d="M136.5 32H132.5V36H136.5V32Z" fill="#E5E5E5" />
      <path d="M136.5 32H132.5V36H136.5V32Z" fill="#DBDBDB" />
      <path d="M124.5 32H128.5V36H124.5V32Z" fill="#E5E5E5" />
      <path d="M124.5 32H128.5V36H124.5V32Z" fill="#DBDBDB" />
      <path d="M120.5 32H116.5V36H120.5V32Z" fill="#E5E5E5" />
      <path d="M120.5 32H116.5V36H120.5V32Z" fill="#DBDBDB" />
      <path d="M108.5 32H112.5V36H108.5V32Z" fill="#E5E5E5" />
      <path d="M108.5 32H112.5V36H108.5V32Z" fill="#DBDBDB" />
      <path d="M104.5 32H100.5V36H104.5V32Z" fill="#E5E5E5" />
      <path d="M104.5 32H100.5V36H104.5V32Z" fill="#DBDBDB" />
      <path d="M92.5 32H96.5V36H92.5V32Z" fill="#E5E5E5" />
      <path d="M92.5 32H96.5V36H92.5V32Z" fill="#DBDBDB" />
      <path d="M188.5 23.996H192.5V27.996H188.5V23.996Z" fill="#E5E5E5" />
      <path d="M188.5 23.996H192.5V27.996H188.5V23.996Z" fill="#DBDBDB" />
      <path d="M184.5 23.996H180.5V27.996H184.5V23.996Z" fill="#E5E5E5" />
      <path d="M184.5 23.996H180.5V27.996H184.5V23.996Z" fill="#DBDBDB" />
      <path d="M172.5 23.996H176.5V27.996H172.5V23.996Z" fill="#E5E5E5" />
      <path d="M172.5 23.996H176.5V27.996H172.5V23.996Z" fill="#DBDBDB" />
      <path d="M168.5 23.996H164.5V27.996H168.5V23.996Z" fill="#E5E5E5" />
      <path d="M168.5 23.996H164.5V27.996H168.5V23.996Z" fill="#DBDBDB" />
      <path d="M156.5 23.996H160.5V27.996H156.5V23.996Z" fill="#E5E5E5" />
      <path d="M156.5 23.996H160.5V27.996H156.5V23.996Z" fill="#DBDBDB" />
      <path d="M152.5 23.996H148.5V27.996H152.5V23.996Z" fill="#E5E5E5" />
      <path d="M152.5 23.996H148.5V27.996H152.5V23.996Z" fill="#DBDBDB" />
      <path d="M140.5 23.996H144.5V27.996H140.5V23.996Z" fill="#E5E5E5" />
      <path d="M140.5 23.996H144.5V27.996H140.5V23.996Z" fill="#DBDBDB" />
      <path d="M136.5 23.996H132.5V27.996H136.5V23.996Z" fill="#E5E5E5" />
      <path d="M136.5 23.996H132.5V27.996H136.5V23.996Z" fill="#DBDBDB" />
      <path d="M124.5 23.996H128.5V27.996H124.5V23.996Z" fill="#E5E5E5" />
      <path d="M124.5 23.996H128.5V27.996H124.5V23.996Z" fill="#DBDBDB" />
      <path d="M120.5 23.996H116.5V27.996H120.5V23.996Z" fill="#E5E5E5" />
      <path d="M120.5 23.996H116.5V27.996H120.5V23.996Z" fill="#DBDBDB" />
      <path d="M108.5 23.996H112.5V27.996H108.5V23.996Z" fill="#E5E5E5" />
      <path d="M108.5 23.996H112.5V27.996H108.5V23.996Z" fill="#DBDBDB" />
      <path d="M104.5 23.996H100.5V27.996H104.5V23.996Z" fill="#E5E5E5" />
      <path d="M104.5 23.996H100.5V27.996H104.5V23.996Z" fill="#DBDBDB" />
      <path d="M92.5 23.996H96.5V27.996H92.5V23.996Z" fill="#E5E5E5" />
      <path d="M92.5 23.996H96.5V27.996H92.5V23.996Z" fill="#DBDBDB" />
      <path d="M188.5 16H192.5V20H188.5V16Z" fill="#E5E5E5" />
      <path d="M188.5 16H192.5V20H188.5V16Z" fill="#DBDBDB" />
      <path d="M184.5 16H180.5V20H184.5V16Z" fill="#E5E5E5" />
      <path d="M184.5 16H180.5V20H184.5V16Z" fill="#DBDBDB" />
      <path d="M172.5 16H176.5V20H172.5V16Z" fill="#E5E5E5" />
      <path d="M172.5 16H176.5V20H172.5V16Z" fill="#DBDBDB" />
      <path d="M168.5 16H164.5V20H168.5V16Z" fill="#E5E5E5" />
      <path d="M168.5 16H164.5V20H168.5V16Z" fill="#DBDBDB" />
      <path d="M156.5 16H160.5V20H156.5V16Z" fill="#E5E5E5" />
      <path d="M156.5 16H160.5V20H156.5V16Z" fill="#DBDBDB" />
      <path d="M152.5 16H148.5V20H152.5V16Z" fill="#E5E5E5" />
      <path d="M152.5 16H148.5V20H152.5V16Z" fill="#DBDBDB" />
      <path d="M140.5 16H144.5V20H140.5V16Z" fill="#E5E5E5" />
      <path d="M140.5 16H144.5V20H140.5V16Z" fill="#DBDBDB" />
      <path d="M136.5 16H132.5V20H136.5V16Z" fill="#E5E5E5" />
      <path d="M136.5 16H132.5V20H136.5V16Z" fill="#DBDBDB" />
      <path d="M124.5 16H128.5V20H124.5V16Z" fill="#E5E5E5" />
      <path d="M124.5 16H128.5V20H124.5V16Z" fill="#DBDBDB" />
      <path d="M120.5 16H116.5V20H120.5V16Z" fill="#E5E5E5" />
      <path d="M120.5 16H116.5V20H120.5V16Z" fill="#DBDBDB" />
      <path d="M108.5 16H112.5V20H108.5V16Z" fill="#E5E5E5" />
      <path d="M108.5 16H112.5V20H108.5V16Z" fill="#DBDBDB" />
      <path d="M104.5 16H100.5V20H104.5V16Z" fill="#E5E5E5" />
      <path d="M104.5 16H100.5V20H104.5V16Z" fill="#DBDBDB" />
      <path d="M92.5 16H96.5V20H92.5V16Z" fill="#E5E5E5" />
      <path d="M92.5 16H96.5V20H92.5V16Z" fill="#DBDBDB" />
      <path d="M188.5 8H192.5V12H188.5V8Z" fill="#E5E5E5" />
      <path d="M188.5 8H192.5V12H188.5V8Z" fill="#DBDBDB" />
      <path d="M184.5 8H180.5V12H184.5V8Z" fill="#E5E5E5" />
      <path d="M184.5 8H180.5V12H184.5V8Z" fill="#DBDBDB" />
      <path d="M172.5 8H176.5V12H172.5V8Z" fill="#E5E5E5" />
      <path d="M172.5 8H176.5V12H172.5V8Z" fill="#DBDBDB" />
      <path d="M168.5 8H164.5V12H168.5V8Z" fill="#E5E5E5" />
      <path d="M168.5 8H164.5V12H168.5V8Z" fill="#DBDBDB" />
      <path d="M156.5 8H160.5V12H156.5V8Z" fill="#E5E5E5" />
      <path d="M156.5 8H160.5V12H156.5V8Z" fill="#DBDBDB" />
      <path d="M152.5 8H148.5V12H152.5V8Z" fill="#E5E5E5" />
      <path d="M152.5 8H148.5V12H152.5V8Z" fill="#DBDBDB" />
      <path d="M140.5 8H144.5V12H140.5V8Z" fill="#E5E5E5" />
      <path d="M140.5 8H144.5V12H140.5V8Z" fill="#DBDBDB" />
      <path d="M136.5 8H132.5V12H136.5V8Z" fill="#E5E5E5" />
      <path d="M136.5 8H132.5V12H136.5V8Z" fill="#DBDBDB" />
      <path d="M124.5 8H128.5V12H124.5V8Z" fill="#E5E5E5" />
      <path d="M124.5 8H128.5V12H124.5V8Z" fill="#DBDBDB" />
      <path d="M120.5 8H116.5V12H120.5V8Z" fill="#E5E5E5" />
      <path d="M120.5 8H116.5V12H120.5V8Z" fill="#DBDBDB" />
      <path d="M108.5 8H112.5V12H108.5V8Z" fill="#E5E5E5" />
      <path d="M108.5 8H112.5V12H108.5V8Z" fill="#DBDBDB" />
      <path d="M104.5 8H100.5V12H104.5V8Z" fill="#E5E5E5" />
      <path d="M104.5 8H100.5V12H104.5V8Z" fill="#DBDBDB" />
      <path d="M92.5 8H96.5V12H92.5V8Z" fill="#E5E5E5" />
      <path d="M92.5 8H96.5V12H92.5V8Z" fill="#DBDBDB" />
      <path d="M188.5 0H192.5V4H188.5V0Z" fill="#E5E5E5" />
      <path d="M188.5 0H192.5V4H188.5V0Z" fill="#DBDBDB" />
      <path d="M184.5 0H180.5V4H184.5V0Z" fill="#E5E5E5" />
      <path d="M184.5 0H180.5V4H184.5V0Z" fill="#DBDBDB" />
      <path d="M172.5 0H176.5V4H172.5V0Z" fill="#E5E5E5" />
      <path d="M172.5 0H176.5V4H172.5V0Z" fill="#DBDBDB" />
      <path d="M168.5 0H164.5V4H168.5V0Z" fill="#E5E5E5" />
      <path d="M168.5 0H164.5V4H168.5V0Z" fill="#DBDBDB" />
      <path d="M156.5 0H160.5V4H156.5V0Z" fill="#E5E5E5" />
      <path d="M156.5 0H160.5V4H156.5V0Z" fill="#DBDBDB" />
      <path d="M152.5 0H148.5V4H152.5V0Z" fill="#E5E5E5" />
      <path d="M152.5 0H148.5V4H152.5V0Z" fill="#DBDBDB" />
      <path d="M140.5 0H144.5V4H140.5V0Z" fill="#E5E5E5" />
      <path d="M140.5 0H144.5V4H140.5V0Z" fill="#DBDBDB" />
      <path d="M136.5 0H132.5V4H136.5V0Z" fill="#E5E5E5" />
      <path d="M136.5 0H132.5V4H136.5V0Z" fill="#DBDBDB" />
      <path d="M124.5 0H128.5V4H124.5V0Z" fill="#E5E5E5" />
      <path d="M124.5 0H128.5V4H124.5V0Z" fill="#DBDBDB" />
      <path d="M120.5 0H116.5V4H120.5V0Z" fill="#E5E5E5" />
      <path d="M120.5 0H116.5V4H120.5V0Z" fill="#DBDBDB" />
      <path d="M108.5 0H112.5V4H108.5V0Z" fill="#E5E5E5" />
      <path d="M108.5 0H112.5V4H108.5V0Z" fill="#DBDBDB" />
      <path d="M104.5 0H100.5V4H104.5V0Z" fill="#E5E5E5" />
      <path d="M104.5 0H100.5V4H104.5V0Z" fill="#DBDBDB" />
      <path d="M92.5 0H96.5V4H92.5V0Z" fill="#E5E5E5" />
      <path d="M92.5 0H96.5V4H92.5V0Z" fill="#DBDBDB" />
      <path
        d="M22.5002 142.653C22.5001 152.694 31.6409 160.253 41.5034 158.369L74.5 152.063V38L35.4978 45.4532C27.9558 46.8945 22.5011 53.4902 22.501 61.1687L22.5002 142.653Z"
        stroke="#101010"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.5 146.274L40.1895 151.493C34.6419 152.553 29.5001 148.301 29.5002 142.653L29.501 61.1687C29.5011 56.8496 32.5693 53.1395 36.8117 52.3288L67.5 46.4644V146.274Z"
        fill="#F3F3F3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.5 153.536L119.499 53.7258L81.5 46.4644V146.274L119.5 153.536Z"
        fill="#F3F3F3"
      />
      <path
        d="M126.5 162L74.5 152.063V38L126.499 47.9368L126.5 162Z"
        stroke="#101010"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M178.5 57.3472C178.5 47.3063 169.359 39.7468 159.497 41.6314L126.5 47.9369V162L165.502 154.547C173.044 153.106 178.499 146.51 178.499 138.831L178.5 57.3472Z"
        stroke="#101010"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M133.5 53.7259L160.811 48.507C166.358 47.4469 171.5 51.6991 171.5 57.3471L171.499 138.831C171.499 143.15 168.431 146.861 164.188 147.671L133.5 153.536V53.7259Z"
        fill="#F3F3F3"
      />
      <rect x="0.5" y="76" width="48" height="48" rx="12" fill="#F83D44" />
      <path
        d="M17.833 93.3335L31.7722 107.273"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.7722 93.3335L17.833 107.273"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconErrorPermissionCam = () => {
  return (
    <svg width="201" height="200" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M200.5 0H196.5V4H200.5V0Z" fill="#E5E5E5" />
      <path d="M200.5 0H196.5V4H200.5V0Z" fill="#DBDBDB" />
      <path d="M200.5 8H196.5V12H200.5V8Z" fill="#E5E5E5" />
      <path d="M200.5 8H196.5V12H200.5V8Z" fill="#DBDBDB" />
      <path d="M200.5 16H196.5V20H200.5V16Z" fill="#E5E5E5" />
      <path d="M200.5 16H196.5V20H200.5V16Z" fill="#DBDBDB" />
      <path d="M200.5 23.996H196.5V27.996H200.5V23.996Z" fill="#E5E5E5" />
      <path d="M200.5 23.996H196.5V27.996H200.5V23.996Z" fill="#DBDBDB" />
      <path d="M200.5 32H196.5V36H200.5V32Z" fill="#E5E5E5" />
      <path d="M200.5 32H196.5V36H200.5V32Z" fill="#DBDBDB" />
      <path d="M200.5 40H196.5V44H200.5V40Z" fill="#E5E5E5" />
      <path d="M200.5 40H196.5V44H200.5V40Z" fill="#DBDBDB" />
      <path d="M200.5 48H196.5V52H200.5V48Z" fill="#E5E5E5" />
      <path d="M200.5 48H196.5V52H200.5V48Z" fill="#DBDBDB" />
      <path d="M200.5 56H196.5V60H200.5V56Z" fill="#E5E5E5" />
      <path d="M200.5 56H196.5V60H200.5V56Z" fill="#DBDBDB" />
      <path d="M200.5 64H196.5V68H200.5V64Z" fill="#E5E5E5" />
      <path d="M200.5 64H196.5V68H200.5V64Z" fill="#DBDBDB" />
      <path d="M200.5 72H196.5V76H200.5V72Z" fill="#E5E5E5" />
      <path d="M200.5 72H196.5V76H200.5V72Z" fill="#DBDBDB" />
      <path d="M200.5 80H196.5V84H200.5V80Z" fill="#E5E5E5" />
      <path d="M200.5 80H196.5V84H200.5V80Z" fill="#DBDBDB" />
      <path d="M200.5 88H196.5V92H200.5V88Z" fill="#E5E5E5" />
      <path d="M200.5 88H196.5V92H200.5V88Z" fill="#DBDBDB" />
      <path d="M200.5 96H196.5V100H200.5V96Z" fill="#E5E5E5" />
      <path d="M200.5 96H196.5V100H200.5V96Z" fill="#DBDBDB" />
      <path d="M92.5 104H96.5V108H92.5V104Z" fill="#E5E5E5" />
      <path d="M92.5 104H96.5V108H92.5V104Z" fill="#DBDBDB" />
      <path d="M104.5 104H100.5V108H104.5V104Z" fill="#E5E5E5" />
      <path d="M104.5 104H100.5V108H104.5V104Z" fill="#DBDBDB" />
      <path d="M108.5 104H112.5V108H108.5V104Z" fill="#E5E5E5" />
      <path d="M108.5 104H112.5V108H108.5V104Z" fill="#DBDBDB" />
      <path d="M120.5 104H116.5V108H120.5V104Z" fill="#E5E5E5" />
      <path d="M120.5 104H116.5V108H120.5V104Z" fill="#DBDBDB" />
      <path d="M124.5 104H128.5V108H124.5V104Z" fill="#E5E5E5" />
      <path d="M124.5 104H128.5V108H124.5V104Z" fill="#DBDBDB" />
      <path d="M136.5 104H132.5V108H136.5V104Z" fill="#E5E5E5" />
      <path d="M136.5 104H132.5V108H136.5V104Z" fill="#DBDBDB" />
      <path d="M140.5 104H144.5V108H140.5V104Z" fill="#E5E5E5" />
      <path d="M140.5 104H144.5V108H140.5V104Z" fill="#DBDBDB" />
      <path d="M152.5 104H148.5V108H152.5V104Z" fill="#E5E5E5" />
      <path d="M152.5 104H148.5V108H152.5V104Z" fill="#DBDBDB" />
      <path d="M156.5 104H160.5V108H156.5V104Z" fill="#E5E5E5" />
      <path d="M156.5 104H160.5V108H156.5V104Z" fill="#DBDBDB" />
      <path d="M168.5 104H164.5V108H168.5V104Z" fill="#E5E5E5" />
      <path d="M168.5 104H164.5V108H168.5V104Z" fill="#DBDBDB" />
      <path d="M172.5 104H176.5V108H172.5V104Z" fill="#E5E5E5" />
      <path d="M172.5 104H176.5V108H172.5V104Z" fill="#DBDBDB" />
      <path d="M184.5 104H180.5V108H184.5V104Z" fill="#E5E5E5" />
      <path d="M184.5 104H180.5V108H184.5V104Z" fill="#DBDBDB" />
      <path d="M188.5 104H192.5V108H188.5V104Z" fill="#E5E5E5" />
      <path d="M188.5 104H192.5V108H188.5V104Z" fill="#DBDBDB" />
      <path d="M196.5 104H200.5V108H196.5V104Z" fill="#E5E5E5" />
      <path d="M196.5 104H200.5V108H196.5V104Z" fill="#DBDBDB" />
      <path d="M188.5 96H192.5V100H188.5V96Z" fill="#E5E5E5" />
      <path d="M188.5 96H192.5V100H188.5V96Z" fill="#DBDBDB" />
      <path d="M184.5 96H180.5V100H184.5V96Z" fill="#E5E5E5" />
      <path d="M184.5 96H180.5V100H184.5V96Z" fill="#DBDBDB" />
      <path d="M172.5 96H176.5V100H172.5V96Z" fill="#E5E5E5" />
      <path d="M172.5 96H176.5V100H172.5V96Z" fill="#DBDBDB" />
      <path d="M168.5 96H164.5V100H168.5V96Z" fill="#E5E5E5" />
      <path d="M168.5 96H164.5V100H168.5V96Z" fill="#DBDBDB" />
      <path d="M156.5 96H160.5V100H156.5V96Z" fill="#E5E5E5" />
      <path d="M156.5 96H160.5V100H156.5V96Z" fill="#DBDBDB" />
      <path d="M152.5 96H148.5V100H152.5V96Z" fill="#E5E5E5" />
      <path d="M152.5 96H148.5V100H152.5V96Z" fill="#DBDBDB" />
      <path d="M140.5 96H144.5V100H140.5V96Z" fill="#E5E5E5" />
      <path d="M140.5 96H144.5V100H140.5V96Z" fill="#DBDBDB" />
      <path d="M136.5 96H132.5V100H136.5V96Z" fill="#E5E5E5" />
      <path d="M136.5 96H132.5V100H136.5V96Z" fill="#DBDBDB" />
      <path d="M124.5 96H128.5V100H124.5V96Z" fill="#E5E5E5" />
      <path d="M124.5 96H128.5V100H124.5V96Z" fill="#DBDBDB" />
      <path d="M120.5 96H116.5V100H120.5V96Z" fill="#E5E5E5" />
      <path d="M120.5 96H116.5V100H120.5V96Z" fill="#DBDBDB" />
      <path d="M108.5 96H112.5V100H108.5V96Z" fill="#E5E5E5" />
      <path d="M108.5 96H112.5V100H108.5V96Z" fill="#DBDBDB" />
      <path d="M104.5 96H100.5V100H104.5V96Z" fill="#E5E5E5" />
      <path d="M104.5 96H100.5V100H104.5V96Z" fill="#DBDBDB" />
      <path d="M92.5 96H96.5V100H92.5V96Z" fill="#E5E5E5" />
      <path d="M92.5 96H96.5V100H92.5V96Z" fill="#DBDBDB" />
      <path d="M188.5 88H192.5V92H188.5V88Z" fill="#E5E5E5" />
      <path d="M188.5 88H192.5V92H188.5V88Z" fill="#DBDBDB" />
      <path d="M184.5 88H180.5V92H184.5V88Z" fill="#E5E5E5" />
      <path d="M184.5 88H180.5V92H184.5V88Z" fill="#DBDBDB" />
      <path d="M172.5 88H176.5V92H172.5V88Z" fill="#E5E5E5" />
      <path d="M172.5 88H176.5V92H172.5V88Z" fill="#DBDBDB" />
      <path d="M168.5 88H164.5V92H168.5V88Z" fill="#E5E5E5" />
      <path d="M168.5 88H164.5V92H168.5V88Z" fill="#DBDBDB" />
      <path d="M156.5 88H160.5V92H156.5V88Z" fill="#E5E5E5" />
      <path d="M156.5 88H160.5V92H156.5V88Z" fill="#DBDBDB" />
      <path d="M152.5 88H148.5V92H152.5V88Z" fill="#E5E5E5" />
      <path d="M152.5 88H148.5V92H152.5V88Z" fill="#DBDBDB" />
      <path d="M140.5 88H144.5V92H140.5V88Z" fill="#E5E5E5" />
      <path d="M140.5 88H144.5V92H140.5V88Z" fill="#DBDBDB" />
      <path d="M136.5 88H132.5V92H136.5V88Z" fill="#E5E5E5" />
      <path d="M136.5 88H132.5V92H136.5V88Z" fill="#DBDBDB" />
      <path d="M124.5 88H128.5V92H124.5V88Z" fill="#E5E5E5" />
      <path d="M124.5 88H128.5V92H124.5V88Z" fill="#DBDBDB" />
      <path d="M120.5 88H116.5V92H120.5V88Z" fill="#E5E5E5" />
      <path d="M120.5 88H116.5V92H120.5V88Z" fill="#DBDBDB" />
      <path d="M108.5 88H112.5V92H108.5V88Z" fill="#E5E5E5" />
      <path d="M108.5 88H112.5V92H108.5V88Z" fill="#DBDBDB" />
      <path d="M104.5 88H100.5V92H104.5V88Z" fill="#E5E5E5" />
      <path d="M104.5 88H100.5V92H104.5V88Z" fill="#DBDBDB" />
      <path d="M92.5 88H96.5V92H92.5V88Z" fill="#E5E5E5" />
      <path d="M92.5 88H96.5V92H92.5V88Z" fill="#DBDBDB" />
      <path d="M188.5 80H192.5V84H188.5V80Z" fill="#E5E5E5" />
      <path d="M188.5 80H192.5V84H188.5V80Z" fill="#DBDBDB" />
      <path d="M184.5 80H180.5V84H184.5V80Z" fill="#E5E5E5" />
      <path d="M184.5 80H180.5V84H184.5V80Z" fill="#DBDBDB" />
      <path d="M172.5 80H176.5V84H172.5V80Z" fill="#E5E5E5" />
      <path d="M172.5 80H176.5V84H172.5V80Z" fill="#DBDBDB" />
      <path d="M168.5 80H164.5V84H168.5V80Z" fill="#E5E5E5" />
      <path d="M168.5 80H164.5V84H168.5V80Z" fill="#DBDBDB" />
      <path d="M156.5 80H160.5V84H156.5V80Z" fill="#E5E5E5" />
      <path d="M156.5 80H160.5V84H156.5V80Z" fill="#DBDBDB" />
      <path d="M152.5 80H148.5V84H152.5V80Z" fill="#E5E5E5" />
      <path d="M152.5 80H148.5V84H152.5V80Z" fill="#DBDBDB" />
      <path d="M140.5 80H144.5V84H140.5V80Z" fill="#E5E5E5" />
      <path d="M140.5 80H144.5V84H140.5V80Z" fill="#DBDBDB" />
      <path d="M136.5 80H132.5V84H136.5V80Z" fill="#E5E5E5" />
      <path d="M136.5 80H132.5V84H136.5V80Z" fill="#DBDBDB" />
      <path d="M124.5 80H128.5V84H124.5V80Z" fill="#E5E5E5" />
      <path d="M124.5 80H128.5V84H124.5V80Z" fill="#DBDBDB" />
      <path d="M120.5 80H116.5V84H120.5V80Z" fill="#E5E5E5" />
      <path d="M120.5 80H116.5V84H120.5V80Z" fill="#DBDBDB" />
      <path d="M108.5 80H112.5V84H108.5V80Z" fill="#E5E5E5" />
      <path d="M108.5 80H112.5V84H108.5V80Z" fill="#DBDBDB" />
      <path d="M104.5 80H100.5V84H104.5V80Z" fill="#E5E5E5" />
      <path d="M104.5 80H100.5V84H104.5V80Z" fill="#DBDBDB" />
      <path d="M92.5 80H96.5V84H92.5V80Z" fill="#E5E5E5" />
      <path d="M92.5 80H96.5V84H92.5V80Z" fill="#DBDBDB" />
      <path d="M188.5 72H192.5V76H188.5V72Z" fill="#E5E5E5" />
      <path d="M188.5 72H192.5V76H188.5V72Z" fill="#DBDBDB" />
      <path d="M184.5 72H180.5V76H184.5V72Z" fill="#E5E5E5" />
      <path d="M184.5 72H180.5V76H184.5V72Z" fill="#DBDBDB" />
      <path d="M172.5 72H176.5V76H172.5V72Z" fill="#E5E5E5" />
      <path d="M172.5 72H176.5V76H172.5V72Z" fill="#DBDBDB" />
      <path d="M168.5 72H164.5V76H168.5V72Z" fill="#E5E5E5" />
      <path d="M168.5 72H164.5V76H168.5V72Z" fill="#DBDBDB" />
      <path d="M156.5 72H160.5V76H156.5V72Z" fill="#E5E5E5" />
      <path d="M156.5 72H160.5V76H156.5V72Z" fill="#DBDBDB" />
      <path d="M152.5 72H148.5V76H152.5V72Z" fill="#E5E5E5" />
      <path d="M152.5 72H148.5V76H152.5V72Z" fill="#DBDBDB" />
      <path d="M140.5 72H144.5V76H140.5V72Z" fill="#E5E5E5" />
      <path d="M140.5 72H144.5V76H140.5V72Z" fill="#DBDBDB" />
      <path d="M136.5 72H132.5V76H136.5V72Z" fill="#E5E5E5" />
      <path d="M136.5 72H132.5V76H136.5V72Z" fill="#DBDBDB" />
      <path d="M124.5 72H128.5V76H124.5V72Z" fill="#E5E5E5" />
      <path d="M124.5 72H128.5V76H124.5V72Z" fill="#DBDBDB" />
      <path d="M120.5 72H116.5V76H120.5V72Z" fill="#E5E5E5" />
      <path d="M120.5 72H116.5V76H120.5V72Z" fill="#DBDBDB" />
      <path d="M108.5 72H112.5V76H108.5V72Z" fill="#E5E5E5" />
      <path d="M108.5 72H112.5V76H108.5V72Z" fill="#DBDBDB" />
      <path d="M104.5 72H100.5V76H104.5V72Z" fill="#E5E5E5" />
      <path d="M104.5 72H100.5V76H104.5V72Z" fill="#DBDBDB" />
      <path d="M92.5 72H96.5V76H92.5V72Z" fill="#E5E5E5" />
      <path d="M92.5 72H96.5V76H92.5V72Z" fill="#DBDBDB" />
      <path d="M188.5 64H192.5V68H188.5V64Z" fill="#E5E5E5" />
      <path d="M188.5 64H192.5V68H188.5V64Z" fill="#DBDBDB" />
      <path d="M184.5 64H180.5V68H184.5V64Z" fill="#E5E5E5" />
      <path d="M184.5 64H180.5V68H184.5V64Z" fill="#DBDBDB" />
      <path d="M172.5 64H176.5V68H172.5V64Z" fill="#E5E5E5" />
      <path d="M172.5 64H176.5V68H172.5V64Z" fill="#DBDBDB" />
      <path d="M168.5 64H164.5V68H168.5V64Z" fill="#E5E5E5" />
      <path d="M168.5 64H164.5V68H168.5V64Z" fill="#DBDBDB" />
      <path d="M156.5 64H160.5V68H156.5V64Z" fill="#E5E5E5" />
      <path d="M156.5 64H160.5V68H156.5V64Z" fill="#DBDBDB" />
      <path d="M152.5 64H148.5V68H152.5V64Z" fill="#E5E5E5" />
      <path d="M152.5 64H148.5V68H152.5V64Z" fill="#DBDBDB" />
      <path d="M140.5 64H144.5V68H140.5V64Z" fill="#E5E5E5" />
      <path d="M140.5 64H144.5V68H140.5V64Z" fill="#DBDBDB" />
      <path d="M136.5 64H132.5V68H136.5V64Z" fill="#E5E5E5" />
      <path d="M136.5 64H132.5V68H136.5V64Z" fill="#DBDBDB" />
      <path d="M124.5 64H128.5V68H124.5V64Z" fill="#E5E5E5" />
      <path d="M124.5 64H128.5V68H124.5V64Z" fill="#DBDBDB" />
      <path d="M120.5 64H116.5V68H120.5V64Z" fill="#E5E5E5" />
      <path d="M120.5 64H116.5V68H120.5V64Z" fill="#DBDBDB" />
      <path d="M108.5 64H112.5V68H108.5V64Z" fill="#E5E5E5" />
      <path d="M108.5 64H112.5V68H108.5V64Z" fill="#DBDBDB" />
      <path d="M104.5 64H100.5V68H104.5V64Z" fill="#E5E5E5" />
      <path d="M104.5 64H100.5V68H104.5V64Z" fill="#DBDBDB" />
      <path d="M92.5 64H96.5V68H92.5V64Z" fill="#E5E5E5" />
      <path d="M92.5 64H96.5V68H92.5V64Z" fill="#DBDBDB" />
      <path d="M188.5 56H192.5V60H188.5V56Z" fill="#E5E5E5" />
      <path d="M188.5 56H192.5V60H188.5V56Z" fill="#DBDBDB" />
      <path d="M184.5 56H180.5V60H184.5V56Z" fill="#E5E5E5" />
      <path d="M184.5 56H180.5V60H184.5V56Z" fill="#DBDBDB" />
      <path d="M172.5 56H176.5V60H172.5V56Z" fill="#E5E5E5" />
      <path d="M172.5 56H176.5V60H172.5V56Z" fill="#DBDBDB" />
      <path d="M168.5 56H164.5V60H168.5V56Z" fill="#E5E5E5" />
      <path d="M168.5 56H164.5V60H168.5V56Z" fill="#DBDBDB" />
      <path d="M156.5 56H160.5V60H156.5V56Z" fill="#E5E5E5" />
      <path d="M156.5 56H160.5V60H156.5V56Z" fill="#DBDBDB" />
      <path d="M152.5 56H148.5V60H152.5V56Z" fill="#E5E5E5" />
      <path d="M152.5 56H148.5V60H152.5V56Z" fill="#DBDBDB" />
      <path d="M140.5 56H144.5V60H140.5V56Z" fill="#E5E5E5" />
      <path d="M140.5 56H144.5V60H140.5V56Z" fill="#DBDBDB" />
      <path d="M136.5 56H132.5V60H136.5V56Z" fill="#E5E5E5" />
      <path d="M136.5 56H132.5V60H136.5V56Z" fill="#DBDBDB" />
      <path d="M124.5 56H128.5V60H124.5V56Z" fill="#E5E5E5" />
      <path d="M124.5 56H128.5V60H124.5V56Z" fill="#DBDBDB" />
      <path d="M120.5 56H116.5V60H120.5V56Z" fill="#E5E5E5" />
      <path d="M120.5 56H116.5V60H120.5V56Z" fill="#DBDBDB" />
      <path d="M108.5 56H112.5V60H108.5V56Z" fill="#E5E5E5" />
      <path d="M108.5 56H112.5V60H108.5V56Z" fill="#DBDBDB" />
      <path d="M104.5 56H100.5V60H104.5V56Z" fill="#E5E5E5" />
      <path d="M104.5 56H100.5V60H104.5V56Z" fill="#DBDBDB" />
      <path d="M92.5 56H96.5V60H92.5V56Z" fill="#E5E5E5" />
      <path d="M92.5 56H96.5V60H92.5V56Z" fill="#DBDBDB" />
      <path d="M188.5 48H192.5V52H188.5V48Z" fill="#E5E5E5" />
      <path d="M188.5 48H192.5V52H188.5V48Z" fill="#DBDBDB" />
      <path d="M184.5 48H180.5V52H184.5V48Z" fill="#E5E5E5" />
      <path d="M184.5 48H180.5V52H184.5V48Z" fill="#DBDBDB" />
      <path d="M172.5 48H176.5V52H172.5V48Z" fill="#E5E5E5" />
      <path d="M172.5 48H176.5V52H172.5V48Z" fill="#DBDBDB" />
      <path d="M168.5 48H164.5V52H168.5V48Z" fill="#E5E5E5" />
      <path d="M168.5 48H164.5V52H168.5V48Z" fill="#DBDBDB" />
      <path d="M156.5 48H160.5V52H156.5V48Z" fill="#E5E5E5" />
      <path d="M156.5 48H160.5V52H156.5V48Z" fill="#DBDBDB" />
      <path d="M152.5 48H148.5V52H152.5V48Z" fill="#E5E5E5" />
      <path d="M152.5 48H148.5V52H152.5V48Z" fill="#DBDBDB" />
      <path d="M140.5 48H144.5V52H140.5V48Z" fill="#E5E5E5" />
      <path d="M140.5 48H144.5V52H140.5V48Z" fill="#DBDBDB" />
      <path d="M136.5 48H132.5V52H136.5V48Z" fill="#E5E5E5" />
      <path d="M136.5 48H132.5V52H136.5V48Z" fill="#DBDBDB" />
      <path d="M124.5 48H128.5V52H124.5V48Z" fill="#E5E5E5" />
      <path d="M124.5 48H128.5V52H124.5V48Z" fill="#DBDBDB" />
      <path d="M120.5 48H116.5V52H120.5V48Z" fill="#E5E5E5" />
      <path d="M120.5 48H116.5V52H120.5V48Z" fill="#DBDBDB" />
      <path d="M108.5 48H112.5V52H108.5V48Z" fill="#E5E5E5" />
      <path d="M108.5 48H112.5V52H108.5V48Z" fill="#DBDBDB" />
      <path d="M104.5 48H100.5V52H104.5V48Z" fill="#E5E5E5" />
      <path d="M104.5 48H100.5V52H104.5V48Z" fill="#DBDBDB" />
      <path d="M92.5 48H96.5V52H92.5V48Z" fill="#E5E5E5" />
      <path d="M92.5 48H96.5V52H92.5V48Z" fill="#DBDBDB" />
      <path d="M188.5 40H192.5V44H188.5V40Z" fill="#E5E5E5" />
      <path d="M188.5 40H192.5V44H188.5V40Z" fill="#DBDBDB" />
      <path d="M184.5 40H180.5V44H184.5V40Z" fill="#E5E5E5" />
      <path d="M184.5 40H180.5V44H184.5V40Z" fill="#DBDBDB" />
      <path d="M172.5 40H176.5V44H172.5V40Z" fill="#E5E5E5" />
      <path d="M172.5 40H176.5V44H172.5V40Z" fill="#DBDBDB" />
      <path d="M168.5 40H164.5V44H168.5V40Z" fill="#E5E5E5" />
      <path d="M168.5 40H164.5V44H168.5V40Z" fill="#DBDBDB" />
      <path d="M156.5 40H160.5V44H156.5V40Z" fill="#E5E5E5" />
      <path d="M156.5 40H160.5V44H156.5V40Z" fill="#DBDBDB" />
      <path d="M152.5 40H148.5V44H152.5V40Z" fill="#E5E5E5" />
      <path d="M152.5 40H148.5V44H152.5V40Z" fill="#DBDBDB" />
      <path d="M140.5 40H144.5V44H140.5V40Z" fill="#E5E5E5" />
      <path d="M140.5 40H144.5V44H140.5V40Z" fill="#DBDBDB" />
      <path d="M136.5 40H132.5V44H136.5V40Z" fill="#E5E5E5" />
      <path d="M136.5 40H132.5V44H136.5V40Z" fill="#DBDBDB" />
      <path d="M124.5 40H128.5V44H124.5V40Z" fill="#E5E5E5" />
      <path d="M124.5 40H128.5V44H124.5V40Z" fill="#DBDBDB" />
      <path d="M120.5 40H116.5V44H120.5V40Z" fill="#E5E5E5" />
      <path d="M120.5 40H116.5V44H120.5V40Z" fill="#DBDBDB" />
      <path d="M108.5 40H112.5V44H108.5V40Z" fill="#E5E5E5" />
      <path d="M108.5 40H112.5V44H108.5V40Z" fill="#DBDBDB" />
      <path d="M104.5 40H100.5V44H104.5V40Z" fill="#E5E5E5" />
      <path d="M104.5 40H100.5V44H104.5V40Z" fill="#DBDBDB" />
      <path d="M92.5 40H96.5V44H92.5V40Z" fill="#E5E5E5" />
      <path d="M92.5 40H96.5V44H92.5V40Z" fill="#DBDBDB" />
      <path d="M188.5 32H192.5V36H188.5V32Z" fill="#E5E5E5" />
      <path d="M188.5 32H192.5V36H188.5V32Z" fill="#DBDBDB" />
      <path d="M184.5 32H180.5V36H184.5V32Z" fill="#E5E5E5" />
      <path d="M184.5 32H180.5V36H184.5V32Z" fill="#DBDBDB" />
      <path d="M172.5 32H176.5V36H172.5V32Z" fill="#E5E5E5" />
      <path d="M172.5 32H176.5V36H172.5V32Z" fill="#DBDBDB" />
      <path d="M168.5 32H164.5V36H168.5V32Z" fill="#E5E5E5" />
      <path d="M168.5 32H164.5V36H168.5V32Z" fill="#DBDBDB" />
      <path d="M156.5 32H160.5V36H156.5V32Z" fill="#E5E5E5" />
      <path d="M156.5 32H160.5V36H156.5V32Z" fill="#DBDBDB" />
      <path d="M152.5 32H148.5V36H152.5V32Z" fill="#E5E5E5" />
      <path d="M152.5 32H148.5V36H152.5V32Z" fill="#DBDBDB" />
      <path d="M140.5 32H144.5V36H140.5V32Z" fill="#E5E5E5" />
      <path d="M140.5 32H144.5V36H140.5V32Z" fill="#DBDBDB" />
      <path d="M136.5 32H132.5V36H136.5V32Z" fill="#E5E5E5" />
      <path d="M136.5 32H132.5V36H136.5V32Z" fill="#DBDBDB" />
      <path d="M124.5 32H128.5V36H124.5V32Z" fill="#E5E5E5" />
      <path d="M124.5 32H128.5V36H124.5V32Z" fill="#DBDBDB" />
      <path d="M120.5 32H116.5V36H120.5V32Z" fill="#E5E5E5" />
      <path d="M120.5 32H116.5V36H120.5V32Z" fill="#DBDBDB" />
      <path d="M108.5 32H112.5V36H108.5V32Z" fill="#E5E5E5" />
      <path d="M108.5 32H112.5V36H108.5V32Z" fill="#DBDBDB" />
      <path d="M104.5 32H100.5V36H104.5V32Z" fill="#E5E5E5" />
      <path d="M104.5 32H100.5V36H104.5V32Z" fill="#DBDBDB" />
      <path d="M92.5 32H96.5V36H92.5V32Z" fill="#E5E5E5" />
      <path d="M92.5 32H96.5V36H92.5V32Z" fill="#DBDBDB" />
      <path d="M188.5 23.996H192.5V27.996H188.5V23.996Z" fill="#E5E5E5" />
      <path d="M188.5 23.996H192.5V27.996H188.5V23.996Z" fill="#DBDBDB" />
      <path d="M184.5 23.996H180.5V27.996H184.5V23.996Z" fill="#E5E5E5" />
      <path d="M184.5 23.996H180.5V27.996H184.5V23.996Z" fill="#DBDBDB" />
      <path d="M172.5 23.996H176.5V27.996H172.5V23.996Z" fill="#E5E5E5" />
      <path d="M172.5 23.996H176.5V27.996H172.5V23.996Z" fill="#DBDBDB" />
      <path d="M168.5 23.996H164.5V27.996H168.5V23.996Z" fill="#E5E5E5" />
      <path d="M168.5 23.996H164.5V27.996H168.5V23.996Z" fill="#DBDBDB" />
      <path d="M156.5 23.996H160.5V27.996H156.5V23.996Z" fill="#E5E5E5" />
      <path d="M156.5 23.996H160.5V27.996H156.5V23.996Z" fill="#DBDBDB" />
      <path d="M152.5 23.996H148.5V27.996H152.5V23.996Z" fill="#E5E5E5" />
      <path d="M152.5 23.996H148.5V27.996H152.5V23.996Z" fill="#DBDBDB" />
      <path d="M140.5 23.996H144.5V27.996H140.5V23.996Z" fill="#E5E5E5" />
      <path d="M140.5 23.996H144.5V27.996H140.5V23.996Z" fill="#DBDBDB" />
      <path d="M136.5 23.996H132.5V27.996H136.5V23.996Z" fill="#E5E5E5" />
      <path d="M136.5 23.996H132.5V27.996H136.5V23.996Z" fill="#DBDBDB" />
      <path d="M124.5 23.996H128.5V27.996H124.5V23.996Z" fill="#E5E5E5" />
      <path d="M124.5 23.996H128.5V27.996H124.5V23.996Z" fill="#DBDBDB" />
      <path d="M120.5 23.996H116.5V27.996H120.5V23.996Z" fill="#E5E5E5" />
      <path d="M120.5 23.996H116.5V27.996H120.5V23.996Z" fill="#DBDBDB" />
      <path d="M108.5 23.996H112.5V27.996H108.5V23.996Z" fill="#E5E5E5" />
      <path d="M108.5 23.996H112.5V27.996H108.5V23.996Z" fill="#DBDBDB" />
      <path d="M104.5 23.996H100.5V27.996H104.5V23.996Z" fill="#E5E5E5" />
      <path d="M104.5 23.996H100.5V27.996H104.5V23.996Z" fill="#DBDBDB" />
      <path d="M92.5 23.996H96.5V27.996H92.5V23.996Z" fill="#E5E5E5" />
      <path d="M92.5 23.996H96.5V27.996H92.5V23.996Z" fill="#DBDBDB" />
      <path d="M188.5 16H192.5V20H188.5V16Z" fill="#E5E5E5" />
      <path d="M188.5 16H192.5V20H188.5V16Z" fill="#DBDBDB" />
      <path d="M184.5 16H180.5V20H184.5V16Z" fill="#E5E5E5" />
      <path d="M184.5 16H180.5V20H184.5V16Z" fill="#DBDBDB" />
      <path d="M172.5 16H176.5V20H172.5V16Z" fill="#E5E5E5" />
      <path d="M172.5 16H176.5V20H172.5V16Z" fill="#DBDBDB" />
      <path d="M168.5 16H164.5V20H168.5V16Z" fill="#E5E5E5" />
      <path d="M168.5 16H164.5V20H168.5V16Z" fill="#DBDBDB" />
      <path d="M156.5 16H160.5V20H156.5V16Z" fill="#E5E5E5" />
      <path d="M156.5 16H160.5V20H156.5V16Z" fill="#DBDBDB" />
      <path d="M152.5 16H148.5V20H152.5V16Z" fill="#E5E5E5" />
      <path d="M152.5 16H148.5V20H152.5V16Z" fill="#DBDBDB" />
      <path d="M140.5 16H144.5V20H140.5V16Z" fill="#E5E5E5" />
      <path d="M140.5 16H144.5V20H140.5V16Z" fill="#DBDBDB" />
      <path d="M136.5 16H132.5V20H136.5V16Z" fill="#E5E5E5" />
      <path d="M136.5 16H132.5V20H136.5V16Z" fill="#DBDBDB" />
      <path d="M124.5 16H128.5V20H124.5V16Z" fill="#E5E5E5" />
      <path d="M124.5 16H128.5V20H124.5V16Z" fill="#DBDBDB" />
      <path d="M120.5 16H116.5V20H120.5V16Z" fill="#E5E5E5" />
      <path d="M120.5 16H116.5V20H120.5V16Z" fill="#DBDBDB" />
      <path d="M108.5 16H112.5V20H108.5V16Z" fill="#E5E5E5" />
      <path d="M108.5 16H112.5V20H108.5V16Z" fill="#DBDBDB" />
      <path d="M104.5 16H100.5V20H104.5V16Z" fill="#E5E5E5" />
      <path d="M104.5 16H100.5V20H104.5V16Z" fill="#DBDBDB" />
      <path d="M92.5 16H96.5V20H92.5V16Z" fill="#E5E5E5" />
      <path d="M92.5 16H96.5V20H92.5V16Z" fill="#DBDBDB" />
      <path d="M188.5 8H192.5V12H188.5V8Z" fill="#E5E5E5" />
      <path d="M188.5 8H192.5V12H188.5V8Z" fill="#DBDBDB" />
      <path d="M184.5 8H180.5V12H184.5V8Z" fill="#E5E5E5" />
      <path d="M184.5 8H180.5V12H184.5V8Z" fill="#DBDBDB" />
      <path d="M172.5 8H176.5V12H172.5V8Z" fill="#E5E5E5" />
      <path d="M172.5 8H176.5V12H172.5V8Z" fill="#DBDBDB" />
      <path d="M168.5 8H164.5V12H168.5V8Z" fill="#E5E5E5" />
      <path d="M168.5 8H164.5V12H168.5V8Z" fill="#DBDBDB" />
      <path d="M156.5 8H160.5V12H156.5V8Z" fill="#E5E5E5" />
      <path d="M156.5 8H160.5V12H156.5V8Z" fill="#DBDBDB" />
      <path d="M152.5 8H148.5V12H152.5V8Z" fill="#E5E5E5" />
      <path d="M152.5 8H148.5V12H152.5V8Z" fill="#DBDBDB" />
      <path d="M140.5 8H144.5V12H140.5V8Z" fill="#E5E5E5" />
      <path d="M140.5 8H144.5V12H140.5V8Z" fill="#DBDBDB" />
      <path d="M136.5 8H132.5V12H136.5V8Z" fill="#E5E5E5" />
      <path d="M136.5 8H132.5V12H136.5V8Z" fill="#DBDBDB" />
      <path d="M124.5 8H128.5V12H124.5V8Z" fill="#E5E5E5" />
      <path d="M124.5 8H128.5V12H124.5V8Z" fill="#DBDBDB" />
      <path d="M120.5 8H116.5V12H120.5V8Z" fill="#E5E5E5" />
      <path d="M120.5 8H116.5V12H120.5V8Z" fill="#DBDBDB" />
      <path d="M108.5 8H112.5V12H108.5V8Z" fill="#E5E5E5" />
      <path d="M108.5 8H112.5V12H108.5V8Z" fill="#DBDBDB" />
      <path d="M104.5 8H100.5V12H104.5V8Z" fill="#E5E5E5" />
      <path d="M104.5 8H100.5V12H104.5V8Z" fill="#DBDBDB" />
      <path d="M92.5 8H96.5V12H92.5V8Z" fill="#E5E5E5" />
      <path d="M92.5 8H96.5V12H92.5V8Z" fill="#DBDBDB" />
      <path d="M188.5 0H192.5V4H188.5V0Z" fill="#E5E5E5" />
      <path d="M188.5 0H192.5V4H188.5V0Z" fill="#DBDBDB" />
      <path d="M184.5 0H180.5V4H184.5V0Z" fill="#E5E5E5" />
      <path d="M184.5 0H180.5V4H184.5V0Z" fill="#DBDBDB" />
      <path d="M172.5 0H176.5V4H172.5V0Z" fill="#E5E5E5" />
      <path d="M172.5 0H176.5V4H172.5V0Z" fill="#DBDBDB" />
      <path d="M168.5 0H164.5V4H168.5V0Z" fill="#E5E5E5" />
      <path d="M168.5 0H164.5V4H168.5V0Z" fill="#DBDBDB" />
      <path d="M156.5 0H160.5V4H156.5V0Z" fill="#E5E5E5" />
      <path d="M156.5 0H160.5V4H156.5V0Z" fill="#DBDBDB" />
      <path d="M152.5 0H148.5V4H152.5V0Z" fill="#E5E5E5" />
      <path d="M152.5 0H148.5V4H152.5V0Z" fill="#DBDBDB" />
      <path d="M140.5 0H144.5V4H140.5V0Z" fill="#E5E5E5" />
      <path d="M140.5 0H144.5V4H140.5V0Z" fill="#DBDBDB" />
      <path d="M136.5 0H132.5V4H136.5V0Z" fill="#E5E5E5" />
      <path d="M136.5 0H132.5V4H136.5V0Z" fill="#DBDBDB" />
      <path d="M124.5 0H128.5V4H124.5V0Z" fill="#E5E5E5" />
      <path d="M124.5 0H128.5V4H124.5V0Z" fill="#DBDBDB" />
      <path d="M120.5 0H116.5V4H120.5V0Z" fill="#E5E5E5" />
      <path d="M120.5 0H116.5V4H120.5V0Z" fill="#DBDBDB" />
      <path d="M108.5 0H112.5V4H108.5V0Z" fill="#E5E5E5" />
      <path d="M108.5 0H112.5V4H108.5V0Z" fill="#DBDBDB" />
      <path d="M104.5 0H100.5V4H104.5V0Z" fill="#E5E5E5" />
      <path d="M104.5 0H100.5V4H104.5V0Z" fill="#DBDBDB" />
      <path d="M92.5 0H96.5V4H92.5V0Z" fill="#E5E5E5" />
      <path d="M92.5 0H96.5V4H92.5V0Z" fill="#DBDBDB" />
      <rect x="42.5" y="42" width="116" height="116" rx="24" stroke="#101010" strokeWidth="4" />
      <rect x="52.5" y="52" width="96" height="96" rx="16" fill="#F3F3F3" />
      <circle cx="100.5" cy="90" r="12" stroke="#101010" strokeWidth="4" />
      <path
        d="M121.5 123C121.5 111.402 112.098 102 100.5 102C88.902 102 79.5 111.402 79.5 123"
        stroke="#101010"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="16.5" y="76" width="48" height="48" rx="12" fill="#F83D44" />
      <path
        d="M33.833 93.3335L47.7722 107.273"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.7722 93.3335L33.833 107.273"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconDoubt = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.79 13.29C9.747 13.3375 9.70692 13.3876 9.67 13.44C9.63216 13.4957 9.60189 13.5563 9.58 13.62C9.55117 13.6767 9.53095 13.7374 9.52 13.8C9.5151 13.8666 9.5151 13.9334 9.52 14C9.51662 14.1312 9.54402 14.2613 9.6 14.38C9.64492 14.5041 9.71657 14.6168 9.80989 14.7101C9.90321 14.8034 10.0159 14.8751 10.14 14.92C10.2597 14.9729 10.3891 15.0002 10.52 15.0002C10.6509 15.0002 10.7803 14.9729 10.9 14.92C11.0241 14.8751 11.1368 14.8034 11.2301 14.7101C11.3234 14.6168 11.3951 14.5041 11.44 14.38C11.4844 14.2584 11.5048 14.1294 11.5 14C11.5008 13.8684 11.4755 13.7379 11.4258 13.6161C11.376 13.4943 11.3027 13.3834 11.21 13.29C11.117 13.1963 11.0064 13.1219 10.8846 13.0711C10.7627 13.0203 10.632 12.9942 10.5 12.9942C10.368 12.9942 10.2373 13.0203 10.1154 13.0711C9.99357 13.1219 9.88297 13.1963 9.79 13.29ZM10.5 0C8.52219 0 6.58879 0.58649 4.9443 1.6853C3.29981 2.78412 2.01809 4.3459 1.26121 6.17317C0.504333 8.00043 0.3063 10.0111 0.692152 11.9509C1.078 13.8907 2.03041 15.6725 3.42894 17.0711C4.82746 18.4696 6.60929 19.422 8.5491 19.8079C10.4889 20.1937 12.4996 19.9957 14.3268 19.2388C16.1541 18.4819 17.7159 17.2002 18.8147 15.5557C19.9135 13.9112 20.5 11.9778 20.5 10C20.5 8.68678 20.2413 7.38642 19.7388 6.17317C19.2362 4.95991 18.4997 3.85752 17.5711 2.92893C16.6425 2.00035 15.5401 1.26375 14.3268 0.761205C13.1136 0.258658 11.8132 0 10.5 0ZM10.5 18C8.91775 18 7.37103 17.5308 6.05544 16.6518C4.73985 15.7727 3.71447 14.5233 3.10897 13.0615C2.50347 11.5997 2.34504 9.99113 2.65372 8.43928C2.9624 6.88743 3.72433 5.46197 4.84315 4.34315C5.96197 3.22433 7.38743 2.4624 8.93928 2.15372C10.4911 1.84504 12.0997 2.00346 13.5615 2.60896C15.0233 3.21447 16.2727 4.23985 17.1518 5.55544C18.0308 6.87103 18.5 8.41775 18.5 10C18.5 12.1217 17.6571 14.1566 16.1569 15.6569C14.6566 17.1571 12.6217 18 10.5 18ZM10.5 5C9.97307 4.99966 9.45534 5.13812 8.99891 5.40144C8.54249 5.66476 8.16347 6.04366 7.9 6.5C7.82765 6.61382 7.77907 6.7411 7.75718 6.87418C7.73529 7.00726 7.74055 7.14339 7.77263 7.27439C7.80472 7.40538 7.86297 7.52854 7.94389 7.63644C8.0248 7.74433 8.12671 7.83475 8.24347 7.90225C8.36024 7.96974 8.48945 8.01292 8.62334 8.02918C8.75722 8.04544 8.89301 8.03446 9.02254 7.99688C9.15207 7.9593 9.27266 7.89591 9.37705 7.81052C9.48145 7.72513 9.56749 7.61951 9.63 7.5C9.71811 7.3474 9.84497 7.22078 9.99775 7.13298C10.1505 7.04518 10.3238 6.9993 10.5 7C10.7652 7 11.0196 7.10536 11.2071 7.29289C11.3946 7.48043 11.5 7.73478 11.5 8C11.5 8.26522 11.3946 8.51957 11.2071 8.70711C11.0196 8.89464 10.7652 9 10.5 9C10.2348 9 9.98043 9.10536 9.7929 9.29289C9.60536 9.48043 9.5 9.73479 9.5 10V11C9.5 11.2652 9.60536 11.5196 9.7929 11.7071C9.98043 11.8946 10.2348 12 10.5 12C10.7652 12 11.0196 11.8946 11.2071 11.7071C11.3946 11.5196 11.5 11.2652 11.5 11V10.82C12.1614 10.58 12.7174 10.1152 13.0708 9.50687C13.4242 8.89851 13.5525 8.18529 13.4334 7.49189C13.3143 6.79849 12.9552 6.16902 12.419 5.71352C11.8828 5.25801 11.2035 5.00546 10.5 5Z"
        fill="#0090FF"
      />
    </svg>
  );
};
